"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[1262],{

/***/ 35544:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Avatar_Avatar)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Avatar/util/getBackgroundColor.ts
const amount = 51;
const diff = Math.floor(360 / amount);
const base = {
    h: 28,
    s: 39,
    l: 64
} // #c7a17f from the figma
;
const magicNumber = 96 // just a shift to set up base color of default initials "SB" from blue to dusty-pink :)
;
const createColors = ()=>{
    let hue = base.h;
    let result = [];
    for(let i = 0; i <= amount; i++){
        // if (excludeCold && hue > 70 && hue < 270) {
        //   hue = 270
        // }
        if (hue > 360) {
            hue = hue - 360;
        } else if (hue === 360) {
            hue = 359;
        } else if (hue <= 0) {
            hue = 1;
        }
        result[i] = hue;
        hue = hue + diff;
    }
    return result.map((h)=>`hsl(${h}, ${base.s}%, ${base.l}%)`);
};
const colorList = createColors();
const getBackgroundColor = (initials)=>{
    if (!initials) {
        return colorList[0];
    }
    let charsCode = (initials.charCodeAt(0) || 0) + (initials.charCodeAt(1) || 0) + magicNumber;
    // let take 'A' (charCode = 65) as first item which will have index = 0
    // so calc index sift for the char (it can be greater than amount of colors so calc remainder from it)
    const index = charsCode % 65 % amount;
    return colorList[index];
};
/* harmony default export */ const util_getBackgroundColor = (getBackgroundColor);

;// CONCATENATED MODULE: ./src/components/dataDisplay/Avatar/Avatar.tsx




const sizeToClassName = {
    32: "w-s32 h-s32 p-[2px]",
    40: "w-s40 h-s40 outline-offset-2"
};
const getLetter = (str)=>str ? str[0] : "";
const Avatar = (props)=>{
    const { className, firstName, lastName, size, isActive, "data-testid": dataTestId } = props;
    const isDefault = firstName === "Scentbird" && lastName === "User";
    const initials = isDefault ? "SB" : `${getLetter(firstName)}${getLetter(lastName)}`;
    const backgroundColor = util_getBackgroundColor(initials);
    const rootClassName = (0,clsx/* default */.Z)(className, "flex flex-none select-none items-stretch overflow-hidden rounded-full", sizeToClassName[size], isActive && "outline outline-1 outline-[var(--av-color)]");
    const innerClassName = (0,clsx/* default */.Z)("flex w-full items-center justify-center rounded-full bg-[var(--av-color)] text-white", size === 40 ? "text-h8" : "text-h9");
    return(// @ts-ignore
    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        style: {
            "--av-color": backgroundColor
        },
        "data-testid": dataTestId,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: innerClassName,
            children: initials
        })
    }));
};
/* harmony default export */ const Avatar_Avatar = (/*#__PURE__*/react.memo(Avatar));


/***/ }),

/***/ 35838:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19460);
/* harmony import */ var _Image_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76884);




const BackgroundImage = (props)=>{
    const { children, className, imageClassName, src, quality, sizes, remWidth, style, lazy } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("figure", {
        className: (0,helpers__WEBPACK_IMPORTED_MODULE_2__/* .twcx */ .L)("relative z-0", className),
        style: style,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Image_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                className: (0,helpers__WEBPACK_IMPORTED_MODULE_2__.cx)("-z-1 select-none", imageClassName),
                fill: true,
                src: src,
                quality: quality,
                sizes: sizes,
                remWidth: remWidth,
                lazy: lazy,
                alt: ""
            }),
            children
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (BackgroundImage);


/***/ }),

/***/ 58094:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ BrandCard_BrandCard)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(614);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(45881);
// EXTERNAL MODULE: ./src/components/layout/AspectContainer/AspectContainer.tsx
var AspectContainer = __webpack_require__(45600);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 5 modules
var Image = __webpack_require__(76884);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/components/dataDisplay/BrandCard/BrandCard.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const BrandCard_module = ({"grayscale":"Mi9eWT","clickable":"WCxBKe","card":"ehAs7N","activeCard":"vMJUFK"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/BrandCard/BrandCard.tsx








const BrandCard = (props)=>{
    const { className, brand, isActive, onClick, ...rest } = props;
    const { name, to, logo } = brand;
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(rest);
    const isClickable = Boolean(to || onClick);
    const handleClick = ()=>{
        if (typeof onClick === "function") {
            onClick(brand);
        }
    };
    const rootClassName = (0,clsx/* default */.Z)(className, {
        "cursor-pointer": isClickable,
        [BrandCard_module.clickable]: isClickable
    });
    const cardClassName = (0,clsx/* default */.Z)(BrandCard_module.card, "border-solid-gray-30 rounded bg-white p-16", {
        [BrandCard_module.activeCard]: isActive
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
        className: rootClassName,
        to: to,
        block: true,
        onClick: handleClick,
        ...htmlAttrs,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: cardClassName,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AspectContainer/* default */.Z, {
                    aspect: 144 / 88,
                    fit: "contain",
                    children: Boolean(logo) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        className: BrandCard_module.grayscale,
                        src: logo,
                        alt: name
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-4 text-center",
                style: "p3",
                children: name
            })
        ]
    });
};
/* harmony default export */ const BrandCard_BrandCard = (/*#__PURE__*/react.memo(BrandCard));


/***/ }),

/***/ 51039:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Carousel_Carousel)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ../../node_modules/.pnpm/glider-js@1.7.8/node_modules/glider-js/glider.js
var glider = __webpack_require__(65017);
var glider_default = /*#__PURE__*/__webpack_require__.n(glider);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Carousel/messages.ts
/* harmony default export */ const messages = ({
    prev: {
        en: "Previous"
    },
    next: {
        en: "Next"
    }
});

;// CONCATENATED MODULE: ./src/components/dataDisplay/Carousel/Carousel.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Carousel_module = ({"carousel":"YT7kzZ"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/Carousel/Carousel.tsx









// TODO: Investigate why memoizing a parent component leads to loss of dots control — added on 21-04-2023 by algeas
const Carousel = /*#__PURE__*/ react.forwardRef((props, forwardedRef)=>{
    const { children, className, withArrows, prevIcon, nextIcon, withDots, // options
    slidesToShow = 1, slidesToScroll = 1, itemWidth, exactWidth, scrollLock = true, scrollLockDelay = 150, resizeLock = true, rewind = false, draggable, duration = true, // autoplay
    autoplay, autoplaySpeed = 2500, // events
    ignoreInitialEvents, onSlideVisible, "data-testid": dataTestId, dataAttributes } = props;
    const { isBot } = (0,useDevice/* default */.Z)();
    const carouselRef = (0,react.useRef)(null);
    const slidesRef = (0,react.useRef)(null);
    const prevArrowRef = (0,react.useRef)(null);
    const nextArrowRef = (0,react.useRef)(null);
    const dotsRef = (0,react.useRef)(null);
    const gliderRef = (0,react.useRef)(null);
    (0,react.useImperativeHandle)(forwardedRef, ()=>({
            scrollItem: (index)=>{
                var _gliderRef_current;
                (_gliderRef_current = gliderRef.current) === null || _gliderRef_current === void 0 ? void 0 : _gliderRef_current.scrollItem(index);
            }
        }));
    // Events
    (0,react.useEffect)(()=>{
        const slidesElement = slidesRef.current;
        // All events are mounted to the slides element
        if (!slidesElement) {
            return;
        }
        const events = {
            "glider-slide-visible": (event)=>{
                if (ignoreInitialEvents && event.timeStamp > 1000) {
                    onSlideVisible(event);
                }
            }
        };
        Object.keys(events).map((event)=>{
            const handler = events[event];
            if (handler) {
                slidesElement.addEventListener(event, handler);
            }
        });
        return ()=>{
            Object.keys(events).map((event)=>{
                const handler = events[event];
                if (handler) {
                    slidesElement.removeEventListener(event, handler);
                }
            });
        };
    }, [
        ignoreInitialEvents,
        onSlideVisible
    ]);
    // Library initialization
    (0,react.useEffect)(()=>{
        if (!slidesRef.current) {
            return;
        }
        const slidesElement = slidesRef.current;
        gliderRef.current = new (glider_default())(slidesElement, {
            skipTrack: true
        });
        // helps to hide broken layout
        slidesElement.classList.add("glider-created");
        return ()=>{
            slidesElement.classList.remove("glider-created");
            gliderRef.current.destroy();
        };
    }, []);
    // Options update when props are updated
    (0,react.useEffect)(()=>{
        if (!gliderRef.current) {
            return;
        }
        gliderRef.current.setOption({
            // default options
            slidesToShow,
            slidesToScroll,
            itemWidth,
            exactWidth,
            scrollLock,
            scrollLockDelay,
            resizeLock,
            rewind,
            draggable,
            duration,
            //
            dots: !withDots ? null : dotsRef.current,
            arrows: !withArrows ? null : {
                prev: prevArrowRef.current,
                next: nextArrowRef.current
            }
        }, true);
        gliderRef.current.refresh(true);
    }, [
        withDots,
        withArrows,
        children,
        slidesToShow,
        slidesToScroll,
        itemWidth,
        exactWidth,
        scrollLock,
        scrollLockDelay,
        resizeLock,
        rewind,
        draggable,
        duration
    ]);
    // Autoplay
    (0,react.useEffect)(()=>{
        const carouselElement = carouselRef.current;
        if (!autoplay || !carouselElement) {
            return;
        }
        let autoplayInterval = null;
        const start = ()=>{
            if (autoplayInterval === null) {
                autoplayInterval = setInterval(()=>{
                    if (gliderRef.current) {
                        gliderRef.current.scrollItem("next");
                        // workaround a problem with not-working rewinding
                        // sometimes glider slides to the next non-existing slide
                        if (gliderRef.current.slide >= gliderRef.current.slides.length) {
                            gliderRef.current.scrollItem(0);
                        }
                    }
                }, autoplaySpeed);
            }
        };
        const stop = ()=>{
            if (autoplayInterval !== null) {
                clearInterval(autoplayInterval);
                autoplayInterval = null;
            }
        };
        carouselElement.addEventListener("mouseover", stop);
        carouselElement.addEventListener("touchstart", stop);
        carouselElement.addEventListener("mouseout", start);
        carouselElement.addEventListener("touchcancel", start);
        carouselElement.addEventListener("touchend", start);
        start();
        return ()=>{
            stop();
            carouselElement.removeEventListener("mouseover", stop);
            carouselElement.removeEventListener("touchstart", stop);
            carouselElement.removeEventListener("mouseout", start);
            carouselElement.removeEventListener("touchcancel", start);
            carouselElement.removeEventListener("touchend", start);
        };
    }, [
        autoplay,
        autoplaySpeed
    ]);
    const intl = (0,useIntl/* default */.Z)();
    const { prevLabel, nextLabel } = (0,react.useMemo)(()=>({
            prevLabel: intl.formatMessage(messages.prev),
            nextLabel: intl.formatMessage(messages.next)
        }), [
        intl
    ]);
    const { trackStyle, slideStyle } = (0,react.useMemo)(()=>{
        if (!itemWidth) {
            return {};
        }
        // this styles are needed to support the same appearance before carousel is initialized
        // the will be replaced by glider-js
        return {
            trackStyle: {
                width: itemWidth * react.Children.count(children)
            },
            slideStyle: {
                width: itemWidth
            }
        };
    }, [
        itemWidth,
        children
    ]);
    const carouselClassName = (0,clsx/* default */.Z)(className, "relative", Carousel_module.carousel);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: carouselRef,
        className: carouselClassName,
        "data-testid": dataTestId,
        ...dataAttributes,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: slidesRef,
                className: (0,clsx/* default */.Z)("glider", isBot && "glider-created"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "glider-track",
                    style: trackStyle,
                    children: react.Children.map(children, (child)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "glider-slide",
                            style: slideStyle,
                            children: child
                        }))
                })
            }),
            Boolean(withArrows) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        ref: prevArrowRef,
                        className: "glider-prev",
                        "aria-label": prevLabel,
                        children: prevIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "32/arrow-left-in-circle"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        ref: nextArrowRef,
                        className: "glider-next",
                        "aria-label": nextLabel,
                        children: nextIcon || /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                            name: "32/arrow-right-in-circle"
                        })
                    })
                ]
            }),
            Boolean(withDots) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: dotsRef,
                className: "glider-dots",
                role: "tablist"
            })
        ]
    });
});
/* harmony default export */ const Carousel_Carousel = (/*#__PURE__*/react.memo(Carousel));


/***/ }),

/***/ 60798:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90234);




const styles = {
    gold: {
        default: "bg-gray-10 border-gray-40 hover:border-gold-50",
        active: "bg-gold-30 border-gold-30 hover:bg-pink hover:border-gold-50",
        disabled: "bg-gray-10 border-gray-30 hover:border-gray-30",
        error: "bg-gray-10 border-red",
        iconColor: "white"
    },
    black: {
        default: "border-black hover:bg-white",
        active: "bg-white border-gold-30 hover:border-black",
        disabled: "border-gray-30 hover:border-gray-30",
        error: "bg-white border-red",
        iconColor: "black"
    }
};
const CheckboxIcon = (props)=>{
    const { className, active, disabled, error, style = "gold" } = props;
    const baseClasses = "flex h-s24 w-s24 flex-none items-center justify-center rounded border transition-all duration-[230ms]";
    const defaultClasses = styles[style].default;
    const activeClasses = styles[style].active;
    const disabledClasses = styles[style].disabled;
    const errorClasses = styles[style].error;
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(baseClasses, className, {
        [`${errorClasses}`]: error,
        [`${activeClasses}`]: active,
        [`${disabledClasses}`]: disabled && !active,
        [`${defaultClasses}`]: !(active || disabled || error)
    }, disabled ? "cursor-not-allowed" : "cursor-pointer");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: rootClassName,
        children: active && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            name: "16/checkmark",
            color: styles[style].iconColor
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CheckboxIcon);


/***/ }),

/***/ 20528:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90234);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78565);




const gapToMarginClassName = {
    0: "",
    4: "mt-4",
    8: "mt-8",
    16: "mt-16",
    24: "mt-24"
};
const checkmarkGapToMarginClassName = {
    8: "mr-8",
    16: "mr-16"
};
const CheckedList = (props)=>{
    const { className, items, gap = 24, checkmarkGap = 16, withCheckmark = true, textStyle = "p2", "data-testid": dataTestId } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: className,
        role: "list",
        "data-testid": dataTestId,
        children: items.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex items-start", index > 0 && gapToMarginClassName[gap]),
                role: "listitem",
                children: [
                    withCheckmark && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("flex-none", checkmarkGapToMarginClassName[checkmarkGap]),
                        name: "24/checkmark",
                        color: "gold-50"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                        className: "pt-1",
                        message: item,
                        style: textStyle,
                        html: true
                    })
                ]
            }, index))
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (CheckedList);


/***/ }),

/***/ 69960:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ZP: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony exports colorToClassName, activeColorToClassName, colorToTextColor, activeColorToTextColor */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var _Text_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78565);




const colorToClassName = {
    "gold-50": "border-solid-gold-50"
};
const activeColorToClassName = {
    "gold-50": "bg-gold-50"
};
const colorToTextColor = {
    "gold-50": "black"
};
const activeColorToTextColor = {
    "gold-50": "white"
};
const Chip = (props)=>{
    const { active, className, color, label, labelStyle = "p2", "data-testid": dataTestId, onClick } = props;
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("inline-block select-none whitespace-nowrap rounded", className || "px-16 py-8", colorToClassName[color], active && activeColorToClassName[color], onClick && "cursor-pointer");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: rootClassName,
        role: "button",
        onClick: onClick,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Text_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            message: label,
            color: active ? activeColorToTextColor["gold-50"] : colorToTextColor["gold-50"],
            style: labelStyle,
            "data-testid": dataTestId
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Chip));


/***/ }),

/***/ 32084:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Disclosure_Disclosure)
});

// UNUSED EXPORTS: titleStyles

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@headlessui+react@1.7.18_react-dom@18.2.0_react@18.2.0/node_modules/@headlessui/react/dist/components/disclosure/disclosure.js + 1 modules
var disclosure = __webpack_require__(92988);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Disclosure/Disclosure.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Disclosure_module = ({"root":"cOrHDq","icon":"fqMALT","activeIcon":"ayRbvV"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/Disclosure/Disclosure.tsx






const titleStyles = (/* unused pure expression or super */ null && ([
    "p2",
    "sh6"
]));
const Disclosure = (props)=>{
    const { children, className, title, text, titleStyle, "data-testid": dataTestId, onClick } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p, {
        className: (0,clsx/* default */.Z)(Disclosure_module.root, className),
        as: "div",
        onClick: onClick,
        "data-testid": dataTestId,
        children: (param)=>{
            let { open } = param;
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(disclosure/* Disclosure */.p.Button, {
                        className: "flex w-full cursor-pointer items-center justify-between py-16 text-black hover:text-gold-30",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: title,
                                style: titleStyle
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                                className: (0,clsx/* default */.Z)(Disclosure_module.icon, open && Disclosure_module.activeIcon),
                                name: "24/plus",
                                color: "gold-50",
                                isInline: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(disclosure/* Disclosure */.p.Panel, {
                        className: "pb-24",
                        children: text ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            message: text,
                            style: "p3",
                            html: true,
                            tag: "div"
                        }) : children
                    })
                ]
            });
        }
    });
};
/* harmony default export */ const Disclosure_Disclosure = (Disclosure);


/***/ }),

/***/ 28259:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78565);




const variantToClassName = {
    "gold": "bg-exclusive-gold-gradient",
    "gold-50": "bg-gold-50",
    "pink": "bg-faded-pink"
};
const ExclusiveLabel = (props)=>{
    const { labelText, variant = "gold" } = props;
    const variantClassName = variantToClassName[variant];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(variantClassName, "ml-16 inline-block px-12 py-4 text-white"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
            message: labelText,
            style: "eye3"
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ExclusiveLabel);


/***/ }),

/***/ 97175:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



const AUTOPLAY_SPEED = 2.5 * 1000;
const FadeCarousel = (props)=>{
    const { autoplaySpeed = AUTOPLAY_SPEED, children, className, slideClassName } = props;
    const [activeIndex, setActiveIndex] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const slidesCount = react__WEBPACK_IMPORTED_MODULE_1__.Children.count(children);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const autoplayInterval = setInterval(()=>{
            setActiveIndex((index)=>{
                const nextIndex = index + 1;
                if (nextIndex === slidesCount) {
                    return 0;
                }
                return nextIndex;
            });
        }, autoplaySpeed);
        return ()=>{
            clearInterval(autoplayInterval);
        };
    }, [
        autoplaySpeed,
        slidesCount
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("relative", className),
        children: react__WEBPACK_IMPORTED_MODULE_1__.Children.map(children, (child, index)=>{
            const active = index === activeIndex;
            const slideClasses = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("absolute w-full min-w-[50rem] select-none content-center justify-center opacity-0 transition-opacity duration-700 ease-in-out", slideClassName, active && "opacity-100");
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: slideClasses,
                children: child
            });
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (FadeCarousel);


/***/ }),

/***/ 42692:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78565);





const HeadlineBlock = (props)=>{
    const { className, supTitle, title, text } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(className, "mx-auto mb-32 max-w-752 text-center"),
        children: [
            Boolean(supTitle) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: "mb-4",
                message: supTitle,
                style: "eye2",
                color: "gold-70"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                message: title,
                style: isMobile ? "h5" : "h4",
                html: true
            }),
            Boolean(text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                className: "mt-16",
                message: text,
                style: "p2",
                html: true
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (HeadlineBlock);


/***/ }),

/***/ 3370:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ HeroMediaBlock_HeroMediaBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/twcx.ts
var twcx = __webpack_require__(19460);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 5 modules
var Image = __webpack_require__(76884);
;// CONCATENATED MODULE: ./src/components/dataDisplay/HeroMediaBlock/HeroMediaBlock.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const HeroMediaBlock_module = ({"wideMT":"svAkYt","wideMB":"u1cXZp"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/HeroMediaBlock/HeroMediaBlock.tsx






const HeroMediaBlock_Image = (param)=>{
    let { className, src, height, alt = "", priority, quality, lazy, bgColor = "bg-light-beige" } = param;
    const style = {
        height: `${height}rem`
    };
    const { isMobile } = (0,useDevice/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
        className: (0,twcx/* twcx */.L)("block w-full object-cover object-center", bgColor, className),
        src: src,
        alt: alt,
        sizes: isMobile ? "100vw" : "(min-width: 1440px) 1440px, (min-width: 1080px) 100vw, 1080px",
        priority: priority,
        lazy: lazy,
        quality: quality,
        style: style
    });
};
const HeroMediaBlock = (props)=>{
    const { children, className, wideMT = true, wideMB = false, title, "data-testid": dataTestId } = props;
    const rootClassName = (0,twcx/* twcx */.L)("mx-auto max-w-1440", {
        [HeroMediaBlock_module.wideMT]: wideMT,
        [HeroMediaBlock_module.wideMB]: wideMB
    }, className);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
        className: rootClassName,
        title: title,
        "data-testid": dataTestId,
        children: children
    });
};
HeroMediaBlock.Image = HeroMediaBlock_Image;
/* harmony default export */ const HeroMediaBlock_HeroMediaBlock = (HeroMediaBlock);


/***/ }),

/***/ 90234:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZP: () => (/* binding */ Icon_Icon)
});

// UNUSED EXPORTS: colors, icons

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/svg-provider/Svg.tsx + 1 modules
var Svg = __webpack_require__(74527);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/16/bubble.svg
const bubble_namespaceObject = __webpack_require__.p + "images-svg/bubble_eb9edf.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/16/checkmark-small.svg
const checkmark_small_namespaceObject = __webpack_require__.p + "images-svg/checkmark-small_d8491b.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/16/checkmark.svg
const checkmark_namespaceObject = __webpack_require__.p + "images-svg/checkmark_fc4333.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/16/close.svg
const close_namespaceObject = __webpack_require__.p + "images-svg/close_2851ed.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/16/dislike.svg
const dislike_namespaceObject = __webpack_require__.p + "images-svg/dislike_90962d.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/16/info.svg
const info_namespaceObject = __webpack_require__.p + "images-svg/info_128c33.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/16/like.svg
const like_namespaceObject = __webpack_require__.p + "images-svg/like_dac8c7.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/20/loader.svg
const loader_namespaceObject = __webpack_require__.p + "images-svg/loader_d2f327.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/20/star.svg
const star_namespaceObject = __webpack_require__.p + "images-svg/star_68695f.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/attention.svg
const attention_namespaceObject = __webpack_require__.p + "images-svg/attention_bf4231.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/birdie.svg
const birdie_namespaceObject = __webpack_require__.p + "images-svg/birdie_d7a679.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/chain.svg
const chain_namespaceObject = __webpack_require__.p + "images-svg/chain_bf2f82.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/checkmark-in-circle.svg
const checkmark_in_circle_namespaceObject = __webpack_require__.p + "images-svg/checkmark-in-circle_e1a461.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/checkmark.svg
const _24_checkmark_namespaceObject = __webpack_require__.p + "images-svg/checkmark_9879c5.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/close.svg
const _24_close_namespaceObject = __webpack_require__.p + "images-svg/close_a80ae2.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/drag.svg
const drag_namespaceObject = __webpack_require__.p + "images-svg/drag_aef9c1.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/info.svg
const _24_info_namespaceObject = __webpack_require__.p + "images-svg/info_0a7307.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/lock.svg
const lock_namespaceObject = __webpack_require__.p + "images-svg/lock_464caf.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/minus.svg
const minus_namespaceObject = __webpack_require__.p + "images-svg/minus_06731e.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/opened-lock.svg
const opened_lock_namespaceObject = __webpack_require__.p + "images-svg/opened-lock_12f92e.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/plus-in-circle.svg
const plus_in_circle_namespaceObject = __webpack_require__.p + "images-svg/plus-in-circle_9950bf.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/plus.svg
const plus_namespaceObject = __webpack_require__.p + "images-svg/plus_0fe524.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/question-black.svg
const question_black_namespaceObject = __webpack_require__.p + "images-svg/question-black_4798a1.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/24/question.svg
const question_namespaceObject = __webpack_require__.p + "images-svg/question_cf2286.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/amex.svg
const amex_namespaceObject = __webpack_require__.p + "images-svg/amex_0fe5ca.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/arrow-down-in-circle.svg
const arrow_down_in_circle_namespaceObject = __webpack_require__.p + "images-svg/arrow-down-in-circle_52ddff.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/arrow-down.svg
const arrow_down_namespaceObject = __webpack_require__.p + "images-svg/arrow-down_e2c861.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/arrow-left-in-circle.svg
const arrow_left_in_circle_namespaceObject = __webpack_require__.p + "images-svg/arrow-left-in-circle_6e485e.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/arrow-left.svg
const arrow_left_namespaceObject = __webpack_require__.p + "images-svg/arrow-left_7a4299.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/arrow-right-in-circle.svg
const arrow_right_in_circle_namespaceObject = __webpack_require__.p + "images-svg/arrow-right-in-circle_0aedb4.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/arrow-right.svg
const arrow_right_namespaceObject = __webpack_require__.p + "images-svg/arrow-right_cf968a.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/arrow-up-in-circle.svg
const arrow_up_in_circle_namespaceObject = __webpack_require__.p + "images-svg/arrow-up-in-circle_b415ac.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/arrow-up.svg
const arrow_up_namespaceObject = __webpack_require__.p + "images-svg/arrow-up_8386b5.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/bell.svg
const bell_namespaceObject = __webpack_require__.p + "images-svg/bell_cf895f.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/birdie.svg
const _32_birdie_namespaceObject = __webpack_require__.p + "images-svg/birdie_126c57.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/burger.svg
const burger_namespaceObject = __webpack_require__.p + "images-svg/burger_70a89c.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/cart.svg
const cart_namespaceObject = __webpack_require__.p + "images-svg/cart_36da1b.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/close-in-circle.svg
const close_in_circle_namespaceObject = __webpack_require__.p + "images-svg/close-in-circle_0a5a31.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/close.svg
const _32_close_namespaceObject = __webpack_require__.p + "images-svg/close_9cc288.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/credit-card.svg
const credit_card_namespaceObject = __webpack_require__.p + "images-svg/credit-card_231862.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/discover.svg
const discover_namespaceObject = __webpack_require__.p + "images-svg/discover_fd1640.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/facebook.svg
const facebook_namespaceObject = __webpack_require__.p + "images-svg/facebook_c62639.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/filters.svg
const filters_namespaceObject = __webpack_require__.p + "images-svg/filters_623a7b.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/instagram.svg
const instagram_namespaceObject = __webpack_require__.p + "images-svg/instagram_70603c.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/loader.svg
const _32_loader_namespaceObject = __webpack_require__.p + "images-svg/loader_ed2ab0.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/maestro.svg
const maestro_namespaceObject = __webpack_require__.p + "images-svg/maestro_df05b1.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/master.svg
const master_namespaceObject = __webpack_require__.p + "images-svg/master_4da886.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/options.svg
const options_namespaceObject = __webpack_require__.p + "images-svg/options_056738.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/personalize.svg
const personalize_namespaceObject = __webpack_require__.p + "images-svg/personalize_536c02.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/pinterest.svg
const pinterest_namespaceObject = __webpack_require__.p + "images-svg/pinterest_62a169.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/question.svg
const _32_question_namespaceObject = __webpack_require__.p + "images-svg/question_e10cb4.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/queue.svg
const queue_namespaceObject = __webpack_require__.p + "images-svg/queue_0fd4c4.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/scentbird-monogram.svg
const scentbird_monogram_namespaceObject = __webpack_require__.p + "images-svg/scentbird-monogram_d19b7c.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/search.svg
const search_namespaceObject = __webpack_require__.p + "images-svg/search_acc70f.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/tiktok.svg
const tiktok_namespaceObject = __webpack_require__.p + "images-svg/tiktok_72c593.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/twitter.svg
const twitter_namespaceObject = __webpack_require__.p + "images-svg/twitter_1ac60d.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/video-gold-arrow.svg
const video_gold_arrow_namespaceObject = __webpack_require__.p + "images-svg/video-gold-arrow_642731.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/32/visa.svg
const visa_namespaceObject = __webpack_require__.p + "images-svg/visa_f81db5.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/36/video-white-arrow.svg
const video_white_arrow_namespaceObject = __webpack_require__.p + "images-svg/video-white-arrow_c8b470.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/amazon-pay.svg
const amazon_pay_namespaceObject = __webpack_require__.p + "images-svg/amazon-pay_85333f.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/apple-pay.svg
const apple_pay_namespaceObject = __webpack_require__.p + "images-svg/apple-pay_399e3c.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/credit-card-error.svg
const credit_card_error_namespaceObject = __webpack_require__.p + "images-svg/credit-card-error_2730d3.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/credit-card.svg
const _40_credit_card_namespaceObject = __webpack_require__.p + "images-svg/credit-card_52db21.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/facebook-in-circle.svg
const facebook_in_circle_namespaceObject = __webpack_require__.p + "images-svg/facebook-in-circle_4d953c.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/facebook.svg
const _40_facebook_namespaceObject = __webpack_require__.p + "images-svg/facebook_2d7a68.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/google-in-circle.svg
const google_in_circle_namespaceObject = __webpack_require__.p + "images-svg/google-in-circle_5eb5ad.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/google.svg
const google_namespaceObject = __webpack_require__.p + "images-svg/google_46e3c8.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/messenger.svg
const messenger_namespaceObject = __webpack_require__.p + "images-svg/messenger_458a78.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/paypal.svg
const paypal_namespaceObject = __webpack_require__.p + "images-svg/paypal_28ce80.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/plus-in-circle.svg
const _40_plus_in_circle_namespaceObject = __webpack_require__.p + "images-svg/plus-in-circle_98f23b.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/40/plus.svg
const _40_plus_namespaceObject = __webpack_require__.p + "images-svg/plus_b78a58.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/authentic-brands.svg
const authentic_brands_namespaceObject = __webpack_require__.p + "images-svg/authentic-brands_0eb30c.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/bestseller.svg
const bestseller_namespaceObject = __webpack_require__.p + "images-svg/bestseller_51f67d.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/cancel-anytime.svg
const cancel_anytime_namespaceObject = __webpack_require__.p + "images-svg/cancel-anytime_675045.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/charity.svg
const charity_namespaceObject = __webpack_require__.p + "images-svg/charity_d8242f.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/clean.svg
const clean_namespaceObject = __webpack_require__.p + "images-svg/clean_90e72f.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/custom-browser.svg
const custom_browser_namespaceObject = __webpack_require__.p + "images-svg/custom-browser_39a67b.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/diamond.svg
const diamond_namespaceObject = __webpack_require__.p + "images-svg/diamond_8a246d.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/flexible-plans.svg
const flexible_plans_namespaceObject = __webpack_require__.p + "images-svg/flexible-plans_947764.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/limited-time.svg
const limited_time_namespaceObject = __webpack_require__.p + "images-svg/limited-time_3c530e.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/new.svg
const new_namespaceObject = __webpack_require__.p + "images-svg/new_c8f519.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/out-of-stock.svg
const out_of_stock_namespaceObject = __webpack_require__.p + "images-svg/out-of-stock_9efe37.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/scentbird-monogram.svg
const _48_scentbird_monogram_namespaceObject = __webpack_require__.p + "images-svg/scentbird-monogram_db2874.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/48/shipping.svg
const shipping_namespaceObject = __webpack_require__.p + "images-svg/shipping_eaa271.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/64/credit-card-attention.svg
const credit_card_attention_namespaceObject = __webpack_require__.p + "images-svg/credit-card-attention_618ee7.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/amazon.svg
const amazon_namespaceObject = __webpack_require__.p + "images-svg/amazon_c3b4c4.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/amex.svg
const other_amex_namespaceObject = __webpack_require__.p + "images-svg/amex_f3970b.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/apple-pay.svg
const other_apple_pay_namespaceObject = __webpack_require__.p + "images-svg/apple-pay_a36d6b.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/apple-store-dark.svg
const apple_store_dark_namespaceObject = __webpack_require__.p + "images-svg/apple-store-dark_368e95.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/apple-store.svg
const apple_store_namespaceObject = __webpack_require__.p + "images-svg/apple-store_b48e5e.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/case-stroke.svg
const case_stroke_namespaceObject = __webpack_require__.p + "images-svg/case-stroke_3dd319.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/discover.svg
const other_discover_namespaceObject = __webpack_require__.p + "images-svg/discover_83e96f.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/google-play-dark.svg
const google_play_dark_namespaceObject = __webpack_require__.p + "images-svg/google-play-dark_8bd2e8.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/google-play.svg
const google_play_namespaceObject = __webpack_require__.p + "images-svg/google-play_20ee25.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/join-scentbird.svg
const join_scentbird_namespaceObject = __webpack_require__.p + "images-svg/join-scentbird_2801d8.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/loader.svg
const other_loader_namespaceObject = __webpack_require__.p + "images-svg/loader_20dc88.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/long-arrow-left.svg
const long_arrow_left_namespaceObject = __webpack_require__.p + "images-svg/long-arrow-left_fb2e9f.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/long-arrow-right.svg
const long_arrow_right_namespaceObject = __webpack_require__.p + "images-svg/long-arrow-right_8afc99.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/master.svg
const other_master_namespaceObject = __webpack_require__.p + "images-svg/master_32e4cd.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/no-items.svg
const no_items_namespaceObject = __webpack_require__.p + "images-svg/no-items_24448c.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/paypal-with-logo.svg
const paypal_with_logo_namespaceObject = __webpack_require__.p + "images-svg/paypal-with-logo_de0e4d.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/paypal.svg
const other_paypal_namespaceObject = __webpack_require__.p + "images-svg/paypal_dc9f61.svg";
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/images/other/product-with-plus.svg
var product_with_plus = __webpack_require__(23431);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/product.svg
const product_namespaceObject = __webpack_require__.p + "images-svg/product_3bb366.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/scentbird-academy-narrow.svg
const scentbird_academy_narrow_namespaceObject = __webpack_require__.p + "images-svg/scentbird-academy-narrow_70173e.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/scentbird-academy.svg
const scentbird_academy_namespaceObject = __webpack_require__.p + "images-svg/scentbird-academy_94bbff.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/scentbird-logo-medium.svg
const scentbird_logo_medium_namespaceObject = __webpack_require__.p + "images-svg/scentbird-logo-medium_912bdd.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/scentbird-logo-small.svg
const scentbird_logo_small_namespaceObject = __webpack_require__.p + "images-svg/scentbird-logo-small_9cec78.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/scentbird-monogram.svg
const other_scentbird_monogram_namespaceObject = __webpack_require__.p + "images-svg/scentbird-monogram_4e10dd.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/shield.svg
const shield_namespaceObject = __webpack_require__.p + "images-svg/shield_ab617a.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/other/visa.svg
const other_visa_namespaceObject = __webpack_require__.p + "images-svg/visa_5e0b58.svg";
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/images/index.ts
/* eslint-disable */ 





























































































































































































































const icons = {
    "16/bubble": {
        src: bubble_namespaceObject,
        source: 0 && 0,
        width: 16,
        height: 16,
        aspect: 1
    },
    "16/checkmark-small": {
        src: checkmark_small_namespaceObject,
        source: 0 && 0,
        width: 16,
        height: 16,
        aspect: 1
    },
    "16/checkmark": {
        src: checkmark_namespaceObject,
        source: 0 && 0,
        width: 16,
        height: 16,
        aspect: 1
    },
    "16/close": {
        src: close_namespaceObject,
        source: 0 && 0,
        width: 16,
        height: 16,
        aspect: 1
    },
    "16/dislike": {
        src: dislike_namespaceObject,
        source: 0 && 0,
        width: 16,
        height: 16,
        aspect: 1
    },
    "16/info": {
        src: info_namespaceObject,
        source: 0 && 0,
        width: 16,
        height: 16,
        aspect: 1
    },
    "16/like": {
        src: like_namespaceObject,
        source: 0 && 0,
        width: 16,
        height: 16,
        aspect: 1
    },
    "20/loader": {
        src: loader_namespaceObject,
        source: 0 && 0,
        width: 20,
        height: 20,
        aspect: 1
    },
    "20/star": {
        src: star_namespaceObject,
        source: 0 && 0,
        width: 20,
        height: 20,
        aspect: 1
    },
    "24/attention": {
        src: attention_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/birdie": {
        src: birdie_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/chain": {
        src: chain_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/checkmark-in-circle": {
        src: checkmark_in_circle_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/checkmark": {
        src: _24_checkmark_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/close": {
        src: _24_close_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/drag": {
        src: drag_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/info": {
        src: _24_info_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/lock": {
        src: lock_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/minus": {
        src: minus_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/opened-lock": {
        src: opened_lock_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/plus-in-circle": {
        src: plus_in_circle_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/plus": {
        src: plus_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/question-black": {
        src: question_black_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "24/question": {
        src: question_namespaceObject,
        source: 0 && 0,
        width: 24,
        height: 24,
        aspect: 1
    },
    "32/amex": {
        src: amex_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/arrow-down-in-circle": {
        src: arrow_down_in_circle_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/arrow-down": {
        src: arrow_down_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/arrow-left-in-circle": {
        src: arrow_left_in_circle_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/arrow-left": {
        src: arrow_left_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/arrow-right-in-circle": {
        src: arrow_right_in_circle_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/arrow-right": {
        src: arrow_right_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/arrow-up-in-circle": {
        src: arrow_up_in_circle_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/arrow-up": {
        src: arrow_up_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/bell": {
        src: bell_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/birdie": {
        src: _32_birdie_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/burger": {
        src: burger_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/cart": {
        src: cart_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/close-in-circle": {
        src: close_in_circle_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/close": {
        src: _32_close_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/credit-card": {
        src: credit_card_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/discover": {
        src: discover_namespaceObject,
        source: 0 && 0,
        width: 30,
        height: 6,
        aspect: 5
    },
    "32/facebook": {
        src: facebook_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/filters": {
        src: filters_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/instagram": {
        src: instagram_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/loader": {
        src: _32_loader_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/maestro": {
        src: maestro_namespaceObject,
        source: 0 && 0,
        width: 29,
        height: 18,
        aspect: 1.6111111111111112
    },
    "32/master": {
        src: master_namespaceObject,
        source: 0 && 0,
        width: 29,
        height: 18,
        aspect: 1.6111111111111112
    },
    "32/options": {
        src: options_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/personalize": {
        src: personalize_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/pinterest": {
        src: pinterest_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/question": {
        src: _32_question_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/queue": {
        src: queue_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/scentbird-monogram": {
        src: scentbird_monogram_namespaceObject,
        source: 0 && 0,
        width: 30,
        height: 28,
        aspect: 1.0714285714285714
    },
    "32/search": {
        src: search_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/tiktok": {
        src: tiktok_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/twitter": {
        src: twitter_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/video-gold-arrow": {
        src: video_gold_arrow_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "32/visa": {
        src: visa_namespaceObject,
        source: 0 && 0,
        width: 32,
        height: 32,
        aspect: 1
    },
    "36/video-white-arrow": {
        src: video_white_arrow_namespaceObject,
        source: 0 && 0,
        width: 36,
        height: 36,
        aspect: 1
    },
    "40/amazon-pay": {
        src: amazon_pay_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/apple-pay": {
        src: apple_pay_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/credit-card-error": {
        src: credit_card_error_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/credit-card": {
        src: _40_credit_card_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/facebook-in-circle": {
        src: facebook_in_circle_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/facebook": {
        src: _40_facebook_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/google-in-circle": {
        src: google_in_circle_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/google": {
        src: google_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/messenger": {
        src: messenger_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/paypal": {
        src: paypal_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/plus-in-circle": {
        src: _40_plus_in_circle_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "40/plus": {
        src: _40_plus_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 40,
        aspect: 1
    },
    "48/authentic-brands": {
        src: authentic_brands_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/bestseller": {
        src: bestseller_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/cancel-anytime": {
        src: cancel_anytime_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/charity": {
        src: charity_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/clean": {
        src: clean_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/custom-browser": {
        src: custom_browser_namespaceObject,
        source: 0 && 0,
        width: 50,
        height: 50,
        aspect: 1
    },
    "48/diamond": {
        src: diamond_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/flexible-plans": {
        src: flexible_plans_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/limited-time": {
        src: limited_time_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/new": {
        src: new_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/out-of-stock": {
        src: out_of_stock_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/scentbird-monogram": {
        src: _48_scentbird_monogram_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "48/shipping": {
        src: shipping_namespaceObject,
        source: 0 && 0,
        width: 48,
        height: 48,
        aspect: 1
    },
    "64/credit-card-attention": {
        src: credit_card_attention_namespaceObject,
        source: 0 && 0,
        width: 64,
        height: 64,
        aspect: 1
    },
    "other/amazon": {
        src: amazon_namespaceObject,
        source: 0 && 0,
        width: 132,
        height: 40,
        aspect: 3.3
    },
    "other/amex": {
        src: other_amex_namespaceObject,
        source: 0 && 0,
        width: 76,
        height: 40,
        aspect: 1.9
    },
    "other/apple-pay": {
        src: other_apple_pay_namespaceObject,
        source: 0 && 0,
        width: 95,
        height: 50,
        aspect: 1.9
    },
    "other/apple-store-dark": {
        src: apple_store_dark_namespaceObject,
        source: 0 && 0,
        width: 168,
        height: 53,
        aspect: 3.169811320754717
    },
    "other/apple-store": {
        src: apple_store_namespaceObject,
        source: 0 && 0,
        width: 168,
        height: 53,
        aspect: 3.169811320754717
    },
    "other/case-stroke": {
        src: case_stroke_namespaceObject,
        source: 0 && 0,
        width: 11,
        height: 44,
        aspect: 0.25
    },
    "other/discover": {
        src: other_discover_namespaceObject,
        source: 0 && 0,
        width: 76,
        height: 40,
        aspect: 1.9
    },
    "other/google-play-dark": {
        src: google_play_dark_namespaceObject,
        source: 0 && 0,
        width: 168,
        height: 53,
        aspect: 3.169811320754717
    },
    "other/google-play": {
        src: google_play_namespaceObject,
        source: 0 && 0,
        width: 168,
        height: 53,
        aspect: 3.169811320754717
    },
    "other/join-scentbird": {
        src: join_scentbird_namespaceObject,
        source: 0 && 0,
        width: 402,
        height: 62,
        aspect: 6.483870967741935
    },
    "other/loader": {
        src: other_loader_namespaceObject,
        source: 0 && 0,
        width: 20,
        height: 20,
        aspect: 1
    },
    "other/long-arrow-left": {
        src: long_arrow_left_namespaceObject,
        source: 0 && 0,
        width: 41,
        height: 16,
        aspect: 2.5625
    },
    "other/long-arrow-right": {
        src: long_arrow_right_namespaceObject,
        source: 0 && 0,
        width: 40,
        height: 16,
        aspect: 2.5
    },
    "other/master": {
        src: other_master_namespaceObject,
        source: 0 && 0,
        width: 76,
        height: 40,
        aspect: 1.9
    },
    "other/no-items": {
        src: no_items_namespaceObject,
        source: 0 && 0,
        width: 146,
        height: 168,
        aspect: 0.8690476190476191
    },
    "other/paypal-with-logo": {
        src: paypal_with_logo_namespaceObject,
        source: 0 && 0,
        width: 132,
        height: 40,
        aspect: 3.3
    },
    "other/paypal": {
        src: other_paypal_namespaceObject,
        source: 0 && 0,
        width: 95,
        height: 26,
        aspect: 3.6538461538461537
    },
    "other/product-with-plus": {
        src: product_with_plus,
        source: 0 && 0,
        width: 120,
        height: 120,
        aspect: 1
    },
    "other/product": {
        src: product_namespaceObject,
        source: 0 && 0,
        width: 384,
        height: 384,
        aspect: 1
    },
    "other/scentbird-academy-narrow": {
        src: scentbird_academy_narrow_namespaceObject,
        source: 0 && 0,
        width: 236,
        height: 73,
        aspect: 3.232876712328767
    },
    "other/scentbird-academy": {
        src: scentbird_academy_namespaceObject,
        source: 0 && 0,
        width: 287,
        height: 46,
        aspect: 6.239130434782608
    },
    "other/scentbird-logo-medium": {
        src: scentbird_logo_medium_namespaceObject,
        source: 0 && 0,
        width: 144,
        height: 32,
        aspect: 4.5
    },
    "other/scentbird-logo-small": {
        src: scentbird_logo_small_namespaceObject,
        source: 0 && 0,
        width: 134,
        height: 32,
        aspect: 4.1875
    },
    "other/scentbird-monogram": {
        src: other_scentbird_monogram_namespaceObject,
        source: 0 && 0,
        width: 77,
        height: 71,
        aspect: 1.0845070422535212
    },
    "other/shield": {
        src: shield_namespaceObject,
        source: 0 && 0,
        width: 28,
        height: 32,
        aspect: 0.875
    },
    "other/visa": {
        src: other_visa_namespaceObject,
        source: 0 && 0,
        width: 76,
        height: 40,
        aspect: 1.9
    }
};
/* harmony default export */ const Icon_images = (icons);

;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/Icon.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Icon_module = ({"other/long-arrow-right":"pdCi2P","other/apple-store":"WKxp_0","other/google-play":"vrrJTZ","other/amazon":"AApQ0z","other/paypal":"SS40Ry","other/scentbird-logo-medium":"g5snXm","other/scentbird-logo-small":"lbtQe0","other/scentbird-monogram":"zVYnsX","other/no-items":"rPAaaj","other/scentbird-academy":"BRKwlW","other/scentbird-academy-narrow":"aE2ToK"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/Icon/Icon.tsx




// ATTN if you have an error here, run generate:icons script


const colors = (/* unused pure expression or super */ null && ([
    "white",
    "gray-30",
    "gray-80",
    "black",
    "gold-30",
    "gold-50",
    "gold-70",
    "green",
    "red"
]));

const colorToClassName = {
    "white": "text-white",
    "black": "text-black",
    "green": "text-green",
    "red": "text-red",
    "gold-30": "text-gold-30",
    "gold-50": "text-gold-50",
    "gold-70": "text-gold-70",
    "gray-30": "text-gray-30",
    "gray-80": "text-gray-80"
};
const sizeToClassName = {
    16: "size-s16",
    20: "size-s20",
    24: "size-s24",
    32: "size-s32",
    40: "size-s40",
    48: "size-s48",
    64: "size-s64"
};
const Icon = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { className, name, color, isInline, ...rest } = props;
    // mock for tests
    if (false) {}
    if (!Icon_images[name]) {
        console.error(`There is no icon with name "${name}"`);
        return null;
    }
    const { src, source, aspect, width, height } = Icon_images[name];
    // we support only square sizes
    const size = width === height ? width : null;
    const rootClassName = (0,clsx/* default */.Z)(className, Icon_module[name], sizeToClassName[size], colorToClassName[color]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Svg/* default */.Z, {
        ref: ref,
        className: rootClassName,
        src: src,
        source: source,
        width: width,
        height: height,
        aspect: aspect,
        symbolId: name,
        isInline: isInline,
        ...rest
    });
});
Icon.displayName = "Icon";
/* harmony default export */ const Icon_Icon = (Icon);


/***/ }),

/***/ 76884:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Image_Image)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/helpers/devicePx.ts
var devicePx = __webpack_require__(21068);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-helmet-async@2.0.4_react-dom@18.2.0_react@18.2.0/node_modules/react-helmet-async/lib/index.esm.js
var index_esm = __webpack_require__(75479);
// EXTERNAL MODULE: ./src/helpers/twcx.ts
var twcx = __webpack_require__(19460);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ./local_modules/crypto-helpers/index.ts
var crypto_helpers = __webpack_require__(63667);
// EXTERNAL MODULE: ./local_modules/config/index.ts
var config = __webpack_require__(59485);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Image/components/NativeImage/util/getZinaImage.ts



const getDeviceResizeValue = (value, customMultiplier)=>{
    var _window___DEVICE__;
    if (customMultiplier) {
        return Math.ceil(value * customMultiplier);
    }
    const multiplier = (typeof window !== "undefined" && !((_window___DEVICE__ = window.__DEVICE__) === null || _window___DEVICE__ === void 0 ? void 0 : _window___DEVICE__.isBot) ? window.devicePixelRatio : 1) || 1;
    return Math.ceil(value * multiplier);
};
const getImgProxyUrl = (props)=>{
    const { src, bgColor, quality, width, height, multiplier, format } = props;
    const parts = [];
    if (width || height) {
        parts.push("rt:fill", width ? `w:${getDeviceResizeValue(width, multiplier)}` : `h:${getDeviceResizeValue(height, multiplier)}`);
    }
    if (quality) {
        parts.push(`fq:jpg:${quality}:avif:${Math.ceil(quality * 50 / 80)}:webp:${quality}`);
    }
    if (bgColor) {
        parts.push(`bg:${bgColor.replace("#", "")}`, `f:jpg`);
    }
    if (format) {
        parts.push(`f:${format}`);
    }
    // we serve files from s3 directly
    parts.push((0,crypto_helpers.encodeBase64)(src.replace("https://cdn.scentbird.com/", "")));
    const url = `/${parts.join("/")}`;
    // we use unsigned urls, because we need to do it on the client side and in sync manner
    return `${config/* default */.Z.imgproxyUrl}/_${url}`;
};
const getZinaImage = (props)=>{
    const { src, bgColor, quality, width, height, multiplier } = props;
    if (!src) {
        return src;
    }
    // imgproxy is enabled
    if (src.charAt(0) !== "/") {
        return getImgProxyUrl(props);
    }
    let finalSrc = src;
    const params = [];
    if (width || height) {
        params.push(width ? `w=${getDeviceResizeValue(width, multiplier)}` : `h=${getDeviceResizeValue(height, multiplier)}`);
    }
    if (quality) {
        params.push(`qlty=${quality}`);
    }
    if (bgColor) {
        params.push(`bgcolor=${bgColor.replace("#", "")}`);
    }
    if (!params.length) {
        return finalSrc;
    }
    return `${finalSrc}?${params.join("&")}`;
};

;// CONCATENATED MODULE: ./src/components/dataDisplay/Image/components/NativeImage/util/getWidths.ts
// if there is no width specified, we apply default set of widths, thinking that image size is 100vw

const deviceSizes = [
    640,
    750,
    828,
    1080,
    1200,
    1440,
    1920,
    2048,
    2272,
    2880,
    3840
];
// when image has custom sizes property
const imageSizes = [
    64,
    96,
    128,
    256,
    384,
    480
];
const allSizes = [
    ...imageSizes,
    ...deviceSizes
].sort((a, b)=>a - b);
const getWidths = (width, sizes)=>{
    // custom size
    if (sizes) {
        // strip all sizes in condition to ignore them
        // e.g. 100vw, (max-width: 200px) 300px will become 100vw, 300px
        const sizesWithoutConditions = sizes.replace(/\(.*?\)/g, "");
        // Find all the "vw" percent sizes used in the sizes prop
        const widthRe = /(^|\s)(\d+)(vw|px)/g;
        const pxSizes = [];
        for(let match; match = widthRe.exec(sizesWithoutConditions); match){
            const value = parseInt(match[2]);
            if (match[3] === "px") {
                pxSizes.push(value) // min size
                ;
                pxSizes.push(value * 3) // max size
                ;
            } else {
                pxSizes.push(deviceSizes[0] * value * 0.01);
                pxSizes.push(deviceSizes[deviceSizes.length - 1] * value * 0.01);
            }
        }
        if (pxSizes.length) {
            const smallestSize = Math.min(...pxSizes);
            const biggestSize = Math.max(...pxSizes);
            // try to find first size bigger or equal than required one
            let existingBiggestSize = allSizes[0];
            for (let size of allSizes){
                existingBiggestSize = size;
                if (size >= biggestSize) {
                    break;
                }
            }
            return {
                widths: allSizes.filter((size)=>size >= smallestSize && size <= existingBiggestSize),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    // no specified width (fill mode), just use predefined sizes
    if (typeof width !== "number") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    // base on width, we find closes pre-defined image size
    const widths = [
        ...new Set(// > are actually 3x in the green color, but only 1.5x in the red and
        // > blue colors. Showing a 3x resolution image in the app vs a 2x
        // > resolution image will be visually the same, though the 3x image
        // > takes significantly more data. Even true 3x resolution screens are
        // > wasteful as the human eye cannot see that level of detail without
        // > something like a magnifying glass.
        // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
        [
            width,
            width * 2
        ].map((w)=>allSizes.find((s)=>s >= w) || allSizes[allSizes.length - 1]))
    ];
    return {
        widths,
        kind: "x"
    };
};

;// CONCATENATED MODULE: ./src/components/dataDisplay/Image/components/NativeImage/util/getImageProps.ts



// eslint-disable-next-line max-len
const placeholderSvg = `<svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 20 20'><path stroke='#DEDEDE' stroke-width='2' d='M19 10a9 9 0 11-9-9'><animateTransform attributeName='transform' type='rotate' from='0 10 10' to='360 10 10' dur='0.6s' repeatCount='indefinite' /></path></svg>`;
const placeholderStyles = {
    backgroundRepeat: "no-repeat",
    backgroundImage: `url("data:image/svg+xml;charset=utf-8,${encodeURIComponent(placeholderSvg)}")`,
    backgroundSize: "20rem",
    backgroundPosition: "50% 50%"
};
const getImageProps = (props, state)=>{
    const { className, // can be src or object from a loader
    src: original, width: customWidth, height: customHeight, alt = "", sizes, bgColor, quality, format, fill = false, priority = false, lazy = true, style, withLoader = true, remWidth, ...rest } = props;
    let unoptimized = false;
    let isLazy = !priority && lazy;
    // original sizes to provide to img tag by default
    let width;
    let height;
    let src;
    if (original) {
        if (typeof original === "string") {
            src = original;
            if (!fill) {
                width = customWidth;
                height = customHeight;
            }
        } else if (typeof original === "object") {
            src = original.src;
            // we don't allow fill with width and height
            if (!fill) {
                // override
                if (!customWidth && !customHeight) {
                    width = original.width;
                    height = original.height;
                } else if (customWidth) {
                    width = customWidth;
                    height = Math.ceil(original.height / original.width * customWidth);
                } else if (customHeight) {
                    width = Math.ceil(original.width / original.height * customHeight);
                    height = customHeight;
                }
            }
        }
    }
    if (!src || src.startsWith("data:") || src.startsWith("blob:")) {
        unoptimized = true;
        isLazy = false;
    } else if (src.endsWith(".svg")) {
        unoptimized = true;
    }
    const result = {
        ...rest,
        className: (0,twcx/* twcx */.L)(fill && "absolute inset-0 h-full w-full object-cover object-center", !state.showAltText && "color-transparent", className),
        srcSet: "",
        src,
        sizes: sizes,
        width,
        height,
        alt,
        loading: isLazy ? "lazy" : undefined,
        decoding: isLazy ? "async" : undefined,
        fetchPriority: priority ? "high" : undefined,
        withLoader,
        style: {
            ...style,
            ...withLoader && !state.blurComplete ? placeholderStyles : {}
        }
    };
    if (fill) {
        result["data-fill"] = "1";
    }
    if (unoptimized) {
        return result;
    }
    const { widths, kind } = getWidths(width, sizes);
    if (!sizes && kind === "w") {
        result.sizes = "100vw";
    }
    result.srcSet = widths.map((width, index)=>{
        const url = getZinaImage({
            src,
            width,
            bgColor,
            quality,
            format,
            multiplier: 1
        });
        // save the last image as a default src
        result.src = url;
        return `${url} ${kind === "w" ? width : index + 1}${kind}`;
    }).join(", ");
    return result;
};

;// CONCATENATED MODULE: ./src/components/dataDisplay/Image/components/NativeImage/NativeImage.tsx





const handleLoading = (img, withLoader, onLoadRef, setBlurComplete)=>{
    const src = img === null || img === void 0 ? void 0 : img.src;
    if (!img || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    const promise = "decode" in img ? img.decode() : Promise.resolve();
    promise.catch(()=>{}).then(()=>{
        if (!img.parentElement || !img.isConnected) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        if (withLoader) {
            (0,react.startTransition)(()=>{
                setBlurComplete(true);
            });
        }
        if (onLoadRef.current) {
            // Since we don't have the SyntheticEvent here,
            // we must create one with the same shape.
            // See https://reactjs.org/docs/events.html
            const event = new Event("load");
            Object.defineProperty(event, "target", {
                writable: false,
                value: img
            });
            let prevented = false;
            let stopped = false;
            onLoadRef.current({
                ...event,
                nativeEvent: event,
                currentTarget: img,
                target: img,
                isDefaultPrevented: ()=>prevented,
                isPropagationStopped: ()=>stopped,
                persist: ()=>{},
                preventDefault: ()=>{
                    prevented = true;
                    event.preventDefault();
                },
                stopPropagation: ()=>{
                    stopped = true;
                    event.stopPropagation();
                }
            });
        }
        if (false) {}
    });
};
const ImageElement = /*#__PURE__*/ (0,react.forwardRef)((props, forwardedRef)=>{
    const { loading, decoding, width, height, alt, style, src, srcSet, sizes, fetchPriority, withLoader, setShowAltText, setBlurComplete, onLoadRef, onError, ...rest } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        ...rest,
        // @ts-ignore for react >=18.3.0 need to use fetchPriority instead
        fetchpriority: fetchPriority,
        // It's intended to keep `loading` before `src` because React updates
        // props in order which causes Safari/Firefox to not lazy load properly.
        // See https://github.com/facebook/react/issues/25883
        loading: loading,
        decoding: decoding,
        width: width,
        height: height,
        alt: alt,
        style: style,
        draggable: false,
        sizes: sizes,
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        srcSet: srcSet,
        src: src,
        ref: (0,react.useCallback)((img)=>{
            if (forwardedRef) {
                if (typeof forwardedRef === "function") {
                    forwardedRef(img);
                } else if (typeof forwardedRef === "object") {
                    // @ts-ignore - .current is read only it's usually assigned by react internally
                    forwardedRef.current = img;
                }
            }
            if (!img) {
                return;
            }
            if (onError) {
                // If the image has an error before react hydrates, then the error is lost.
                // The workaround is to wait until the image is mounted which is after hydration,
                // then we set the src again to trigger the error handler (if there was an error).
                // eslint-disable-next-line no-self-assign
                img.src = img.src;
            }
            if (false) {}
            if (img.complete) {
                handleLoading(img, withLoader, onLoadRef, setBlurComplete);
            }
        }, [
            alt,
            forwardedRef,
            onError,
            onLoadRef,
            setBlurComplete,
            src,
            withLoader
        ]),
        onLoad: (event)=>{
            const img = event.currentTarget;
            handleLoading(img, withLoader, onLoadRef, setBlurComplete);
        },
        onError: (event)=>{
            // if the real image fails to load, this will ensure "alt" is visible
            (0,react.startTransition)(()=>{
                setShowAltText(true);
                if (withLoader) {
                    // If the real image fails to load, this will still remove the placeholder.
                    setBlurComplete(true);
                }
            });
            if (typeof onError === "function") {
                onError(event);
            }
        }
    });
});
const NativeImage = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const [blurComplete, setBlurComplete] = (0,react.useState)(false);
    const [showAltText, setShowAltText] = (0,react.useState)(false);
    const onLoadRef = (0,react.useRef)(props.onLoad);
    onLoadRef.current = props.onLoad;
    const imgProps = getImageProps(props, {
        blurComplete,
        showAltText
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageElement, {
                ...imgProps,
                ref: ref,
                setBlurComplete: setBlurComplete,
                setShowAltText: setShowAltText,
                onLoadRef: onLoadRef
            }),
            imgProps.fetchPriority && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Helmet */.ql, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    imageSrcSet: imgProps.srcSet,
                    imageSizes: imgProps.sizes,
                    // @ts-ignore
                    fetchpriority: "high"
                })
            })
        ]
    });
});
/* harmony default export */ const NativeImage_NativeImage = (NativeImage);

// EXTERNAL MODULE: ./local_modules/throttle-debounce/debounce.ts
var debounce = __webpack_require__(12196);
// EXTERNAL MODULE: ./local_modules/logger/index.ts
var logger = __webpack_require__(53297);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Image/components/NativeImageWrapper/NativeImageWrapper.tsx





const useIsomorphicEffect =  true ? react.useLayoutEffect : 0;
const getPlaceholder = function() {
    let aspect = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
    return `data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${aspect} 1'%3e%3c/svg%3e`;
};
const NativeImageWrapper = (props)=>{
    const nodeRef = (0,react.useRef)();
    const [sizes, setSizes] = (0,react.useState)(props.sizes);
    const aspect = typeof props.src === "object" && props.src.height > 0 ? props.src.width / props.src.height : 1;
    useIsomorphicEffect(()=>{
        const node = nodeRef === null || nodeRef === void 0 ? void 0 : nodeRef.current;
        if (!node) {
            return;
        }
        let isMounted = true;
        let lastWidth = null;
        const update = ()=>{
            if (!isMounted) {
                return;
            }
            const width = node.clientWidth;
            if (lastWidth < width) {
                const sizes = `${Math.ceil(width)}px`;
                if (false) {}
                (0,react.startTransition)(()=>{
                    setSizes(sizes);
                });
            }
            lastWidth = width;
        };
        const debouncedUpdate = (0,debounce/* default */.Z)(()=>update(), 100);
        update();
        let resizeObserver;
        try {
            if (typeof ResizeObserver !== "undefined") {
                resizeObserver = new ResizeObserver(debouncedUpdate);
                resizeObserver.observe(node);
            }
        } catch (error) {
            logger/* default */.Z.warn(error);
        }
        return ()=>{
            isMounted = false;
            if (resizeObserver) {
                resizeObserver.unobserve(node);
                resizeObserver.disconnect();
                debouncedUpdate.cancel();
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeImage_NativeImage, {
        ...props,
        ref: nodeRef,
        sizes: sizes,
        src: sizes ? props.src : getPlaceholder(aspect)
    });
};
/* harmony default export */ const NativeImageWrapper_NativeImageWrapper = (NativeImageWrapper);

;// CONCATENATED MODULE: ./src/components/dataDisplay/Image/Image.tsx






const Image = (props)=>{
    const { isBot, isMobile, isTablet } = (0,useDevice/* default */.Z)();
    // if it's a real client, and we don't have provided size properties,
    // we use a wrapper which provides sizes measurements
    if (!isBot && !props.sizes && !props.width && !props.height && !props.remWidth) {
        let src;
        let srcWithSize = false;
        if (typeof props.src === "string") {
            src = props.src;
        } else if (props.src) {
            src = props.src.src;
            srcWithSize = Boolean(props.src.width && props.src.height);
        }
        if (src && !src.endsWith(".svg") && !srcWithSize) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeImageWrapper_NativeImageWrapper, {
                ...props
            });
        }
    }
    // little helper to remove code duplication if you need to set specific size of the image
    let sizes = undefined;
    let width = undefined;
    const { remWidth } = props;
    if (remWidth) {
        if (isMobile && !isTablet) {
            sizes = (0,devicePx/* deviceVm */.o)(remWidth);
        } else if (props.fill) {
            sizes = `${remWidth}px`;
        } else {
            width = Number(remWidth);
        }
    } else {
        sizes = props.sizes;
        width = props.width;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NativeImage_NativeImage, {
        ...props,
        sizes: sizes,
        width: width,
        withLoader: isBot ? false : props.withLoader
    });
};
/* harmony default export */ const Image_Image = (Image);


/***/ }),

/***/ 77883:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZP: () => (/* binding */ Label_Label)
});

// UNUSED EXPORTS: bgColorToClassName, colorToClassName, indentToClassName

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/twcx.ts
var twcx = __webpack_require__(19460);
// EXTERNAL MODULE: ./src/components/dataDisplay/RichText/RichText.tsx + 1 modules
var RichText = __webpack_require__(19384);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Label/Label.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Label_module = ({"withTail":"Jjy8G1","direction-left":"kHJMdH","direction-right":"L3gsZu"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/Label/Label.tsx





const bgColorToClassName = {
    "black": "bg-black",
    "brown-red": "bg-brown-red",
    "gold-30": "bg-gold-30",
    "gold-70": "bg-gold-70",
    "faded-pink": "bg-faded-pink",
    "vinous": "bg-vinous"
};
const colorToClassName = {
    "white": "text-white",
    "black": "text-black",
    "gold-30": "text-gold-30"
};
const indentToClassName = {
    16: "pl-16",
    32: "pl-32",
    40: "pl-40",
    56: "pl-56"
};
const Label = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { className, absolute = false, bgColor, indent, direction = "left", withTail, style = "eye3", html, "data-testid": dataTestId } = props;
    const rootClassName = (0,twcx/* twcx */.L)("inline-block whitespace-nowrap px-[14rem] py-[5rem]", absolute ? "absolute" : "relative", bgColorToClassName[bgColor], "textColor" in props ? colorToClassName[props.textColor] : undefined, direction === "left" && indentToClassName[indent], className, {
        [Label_module[`direction-${direction}`]]: direction,
        [Label_module.withTail]: withTail
    });
    const isRichText = "richText" in props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-testid": dataTestId,
        children: isRichText ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
            ref: ref,
            message: props.richText
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            ref: ref,
            message: props.title,
            style: style,
            color: props.textColor,
            html: html
        })
    });
});
Label.displayName = "Label";
/* harmony default export */ const Label_Label = (Label);


/***/ }),

/***/ 53409:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96934);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45881);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(90234);





const Logo = (props)=>{
    const { className, to, color, onClick } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        name: isMobile ? "other/scentbird-logo-small" : "other/scentbird-logo-medium",
        color: color
    });
    if (to) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_navigation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: className,
            to: to,
            onClick: onClick,
            children: icon
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: className,
        children: icon
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Logo);


/***/ }),

/***/ 8857:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ MediaHeadlineBlock_MediaHeadlineBlock)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/dataDisplay/Label/Label.tsx + 1 modules
var Label = __webpack_require__(77883);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/components/dataDisplay/MediaHeadlineBlock/MediaHeadlineBlock.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const MediaHeadlineBlock_module = ({"h2":"Pr6Fyc","h3":"jjIGHR","h4":"ZBOaS9","label":"ECWmHG"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/MediaHeadlineBlock/MediaHeadlineBlock.tsx





const MediaHeadlineBlock = (props)=>{
    const { className, title, text, label, labelBgColor = "black", titleStyle, titleTag, indent, children } = props;
    const rootClassName = (0,clsx/* default */.Z)(className, MediaHeadlineBlock_module[titleStyle], "relative max-w-752 text-left", {
        [`pl-${indent}`]: indent
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: rootClassName,
        children: [
            Boolean(label) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.ZP, {
                className: MediaHeadlineBlock_module.label,
                title: label,
                bgColor: labelBgColor,
                textColor: "white",
                indent: indent
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: title,
                style: titleStyle,
                tag: titleTag,
                html: true
            }),
            Boolean(text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: titleStyle === "h2" ? "mt-16" : "mt-8",
                message: text,
                style: "p2",
                html: true
            }),
            children
        ]
    });
};
/* harmony default export */ const MediaHeadlineBlock_MediaHeadlineBlock = (MediaHeadlineBlock);


/***/ }),

/***/ 95148:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var react_helmet_async__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75479);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2129);




const multiLineToOneLine = (src)=>src.replace(/\n\s*|\s{2,}/mg, " ").trim();
const Meta = (props)=>{
    const { title, metaTitle, metaDescription, keywords, image, pathname, withoutTitleTemplate } = props;
    const intl = (0,intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const pageTitle = intl.formatMessage(title);
    const pageMetaTitle = metaTitle ? intl.formatMessage(metaTitle) : pageTitle;
    const pageMetaDescription = metaDescription ? multiLineToOneLine(intl.formatMessage(metaDescription)) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_helmet_async__WEBPACK_IMPORTED_MODULE_3__/* .Helmet */ .ql, {
        titleTemplate: withoutTitleTemplate ? null : "%s | Scentbird.com",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: pageTitle
            }),
            Boolean(pageMetaTitle) && [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "title",
                    content: pageMetaTitle
                }, "title"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: pageMetaTitle
                }, "og:title")
            ],
            Boolean(pageMetaDescription) && [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: pageMetaDescription
                }, "description"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: pageMetaDescription
                }, "og:description")
            ],
            Boolean(keywords) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }, "keywords"),
            Boolean(image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image
            }, "og:image"),
            Boolean(pathname) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: `https://www.scentbird.com${pathname}`
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }, "og:type")
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(Meta));


/***/ }),

/***/ 36886:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export colors */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78565);




const colors = (/* unused pure expression or super */ null && ([
    "black",
    "pink"
]));
const OfferLabel = (props)=>{
    const { className, title, bgColor = "black", "data-testid": dataTestId } = props;
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(className, "inline-block rounded-2 px-8 py-4", {
        "bg-black text-white": bgColor === "black",
        "bg-pink text-black": bgColor === "pink"
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
        className: rootClassName,
        message: title,
        style: "p5",
        "data-testid": dataTestId
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (OfferLabel);


/***/ }),

/***/ 85319:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);



// [ bgColor, arrowColor ]
const styleToClasses = {
    "default": [
        "text-black",
        "text-gold-30"
    ],
    "drift": [
        "text-black-100",
        "text-white"
    ],
    "gold-30": [
        "text-gold-30",
        "text-black"
    ],
    "gold-70-white": [
        "text-gold-70",
        "text-white"
    ]
};
const PlayIcon = (props)=>{
    const { className, size = 72, style = "default" } = props;
    const rootClassName = (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("block", className, {
        "w-s72 h-s72": size === 72,
        "w-s60 h-s60": size === 60,
        "w-s18 h-s18": size === 18
    });
    const [bgColor, arrowColor] = styleToClasses[style] || styleToClasses.default;
    // special view for the small icon
    if (size === 18) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
            className: rootClassName,
            width: size,
            height: size,
            viewBox: "0 0 18 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                    className: bgColor,
                    width: "18",
                    height: "18",
                    rx: "9",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                    className: arrowColor,
                    d: "M7 13V5L12 9L7 13Z",
                    fill: "currentColor"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        className: rootClassName,
        width: size,
        height: size,
        viewBox: "0 0 60 60",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                className: bgColor,
                cx: "30",
                cy: "30",
                r: "30",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                className: arrowColor,
                d: "M21.6665 43.3333V17.5L44.1665 30.4167L21.6665 43.3333Z",
                fill: "currentColor"
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PlayIcon);


/***/ }),

/***/ 5576:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ ProductCountImage_ProductCountImage)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/helpers/twcx.ts
var twcx = __webpack_require__(19460);
// EXTERNAL MODULE: ./src/helpers/primitives/array.ts
var array = __webpack_require__(59909);
// EXTERNAL MODULE: ./src/components/dataDisplay/Icon/Icon.tsx + 112 modules
var Icon = __webpack_require__(90234);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 5 modules
var Image = __webpack_require__(76884);
;// CONCATENATED MODULE: ./src/components/dataDisplay/ProductCountImage/images/case.png
const case_namespaceObject = __webpack_require__.p + "images/case_37c2e6.png";
;// CONCATENATED MODULE: ./src/components/dataDisplay/ProductCountImage/images/case.png?src-loader

/* harmony default export */ const casesrc_loader = ({ src: case_namespaceObject, aspect: 0.2688, width: 721, height: 2682 });
;// CONCATENATED MODULE: ./src/components/dataDisplay/ProductCountImage/images/case-empty.png
const case_empty_namespaceObject = __webpack_require__.p + "images/case-empty_cf9672.png";
;// CONCATENATED MODULE: ./src/components/dataDisplay/ProductCountImage/images/case-empty.png?src-loader

/* harmony default export */ const case_emptysrc_loader = ({ src: case_empty_namespaceObject, aspect: 0.3175, width: 214, height: 674 });
;// CONCATENATED MODULE: ./src/components/dataDisplay/ProductCountImage/images/flask.png
const flask_namespaceObject = __webpack_require__.p + "images/flask_35007d.png";
;// CONCATENATED MODULE: ./src/components/dataDisplay/ProductCountImage/images/flask.png?src-loader

/* harmony default export */ const flasksrc_loader = ({ src: flask_namespaceObject, aspect: 0.1921, width: 516, height: 2686 });
;// CONCATENATED MODULE: ./src/components/dataDisplay/ProductCountImage/ProductCountImage.tsx







const ProductCountImage_images = {
    case: casesrc_loader,
    ["case-empty"]: case_emptysrc_loader,
    flask: flasksrc_loader
};
const icons = {
    "case-stroke": "other/case-stroke"
};
const ProductCountImage = (props)=>{
    const { className, imageClassName, count, imageType } = props;
    const rootClassName = (0,twcx/* twcx */.L)("flex justify-center", className);
    const finalImageClassName = (0,twcx/* twcx */.L)("w-auto", imageType !== "case" ? "mx-4" : "mx-4 my-8", imageClassName);
    const isIcon = Boolean(icons[imageType]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        children: array/* default */.Z.range(1, count).map((_, index)=>isIcon ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon/* default */.ZP, {
                className: finalImageClassName,
                name: icons[imageType]
            }, index) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: finalImageClassName,
                alt: imageType,
                src: ProductCountImage_images[imageType],
                remWidth: 32
            }, index))
    });
};
/* harmony default export */ const ProductCountImage_ProductCountImage = (ProductCountImage);


/***/ }),

/***/ 12166:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78364);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78565);




const Progress = (props)=>{
    const { children, className, message, progress, textStyle = "p4", "data-testid": dataTestId } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,classnames__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)("-mt-16", className),
        "data-testid": dataTestId,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center justify-between",
                children: Boolean(message) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    message: message,
                    style: textStyle,
                    html: true
                })
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-8 h-8 bg-gray-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-full bg-gold-30 transition-all duration-500 ease-ease-in-out",
                    style: {
                        width: `${progress}%`
                    }
                })
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Progress);


/***/ }),

/***/ 31184:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ PromoCardContainer_PromoCardContainer)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/navigation/Href/Href.tsx
var Href = __webpack_require__(45881);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/dataDisplay/MediaHeadlineBlock/MediaHeadlineBlock.tsx + 1 modules
var MediaHeadlineBlock = __webpack_require__(8857);
// EXTERNAL MODULE: ./src/components/inputs/ActionButton/ActionButton.tsx
var ActionButton = __webpack_require__(49952);
;// CONCATENATED MODULE: ./src/components/dataDisplay/PromoCardContainer/PromoCardContainer.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const PromoCardContainer_module = ({"titlePlacement":"a_Ou9K"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/PromoCardContainer/PromoCardContainer.tsx







const PromoCardContainer = /*#__PURE__*/ (0,react.forwardRef)((props, ref)=>{
    const { children, className, label, title, titleStyle = "h3", titleTag, text, action, indent = 16, withHighlight, dataTestId } = props;
    const mediaContent = /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative overflow-hidden",
        children: [
            children,
            withHighlight && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: (0,clsx/* default */.Z)(PromoCardContainer_module.titlePlacement, indent && `ml-${indent}`),
                message: title,
                style: titleStyle,
                html: true
            })
        ]
    });
    if (action) {
        const { to, toTab, href, onClick } = action;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Href/* default */.Z, {
            className: (0,clsx/* default */.Z)(className, "pb-8"),
            to: to,
            toTab: toTab,
            href: href,
            onClick: onClick,
            ref: ref,
            "data-testid": dataTestId,
            children: [
                mediaContent,
                /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaHeadlineBlock/* default */.Z, {
                    title: title,
                    titleStyle: titleStyle,
                    titleTag: titleTag,
                    text: text,
                    label: label,
                    indent: indent,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActionButton/* default */.Z, {
                        className: "mt-16",
                        title: action.title,
                        style: "gold-50"
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "pb-8"),
        ref: ref,
        "data-testid": dataTestId,
        children: [
            mediaContent,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MediaHeadlineBlock/* default */.Z, {
                title: title,
                titleStyle: titleStyle,
                titleTag: titleTag,
                text: text,
                label: label,
                indent: indent
            })
        ]
    });
});
/* harmony default export */ const PromoCardContainer_PromoCardContainer = (/*#__PURE__*/react.memo(PromoCardContainer));


/***/ }),

/***/ 32359:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ RadioIcon_RadioIcon)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
;// CONCATENATED MODULE: ./src/components/dataDisplay/RadioIcon/RadioIcon.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const RadioIcon_module = ({"icon":"_PPdYK","active":"b45Yt1"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/RadioIcon/RadioIcon.tsx




const RadioIcon = (props)=>{
    const { className, active } = props;
    const rootClassName = (0,clsx/* default */.Z)(RadioIcon_module.icon, "h-s24 w-s24", className, {
        [RadioIcon_module.active]: active
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: rootClassName,
        "data-active": active
    });
};
/* harmony default export */ const RadioIcon_RadioIcon = (RadioIcon);


/***/ }),

/***/ 75393:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32359);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78565);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38110);




const RadioOptionSimpleView = (props)=>{
    const { label, checked, disabled } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex items-start py-12 text-left",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                active: checked
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.Label, {
                as: components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP,
                className: "w-full pl-16",
                message: label,
                tag: "label",
                style: "p2",
                color: disabled ? "gray-80" : "black",
                html: true
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (RadioOptionSimpleView);


/***/ }),

/***/ 88336:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Rating_Rating)
});

// UNUSED EXPORTS: sizes

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(2129);
// EXTERNAL MODULE: ./src/helpers/primitives/array.ts
var array = __webpack_require__(59909);
// EXTERNAL MODULE: ./src/hooks/useUniqueId.ts
var useUniqueId = __webpack_require__(91327);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(614);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Rating/util/useRatingKeyboard.ts

const useRatingKeyboard = (param)=>{
    let { activeRating } = param;
    const ratingContainerRef = (0,react.useRef)();
    const activeIndex = (0,react.useRef)(activeRating);
    activeIndex.current = activeRating - 1;
    (0,react.useEffect)(()=>{
        var _ratingContainerRef_current;
        const stars = Array.from(((_ratingContainerRef_current = ratingContainerRef.current) === null || _ratingContainerRef_current === void 0 ? void 0 : _ratingContainerRef_current.children) || []);
        if (stars.length) {
            const handleKeyDown = (event)=>{
                const isUp = [
                    39,
                    38
                ].includes(event.keyCode);
                const isDown = [
                    37,
                    40
                ].includes(event.keyCode);
                const isRatingChange = isUp || isDown;
                if (isRatingChange) {
                    var _ratingContainerRef_current, _activeStar_focus;
                    const nextIndex = isUp ? activeIndex.current + 1 : activeIndex.current - 1;
                    const activeStar = Array.from(((_ratingContainerRef_current = ratingContainerRef.current) === null || _ratingContainerRef_current === void 0 ? void 0 : _ratingContainerRef_current.children) || [])[nextIndex];
                    activeStar === null || activeStar === void 0 ? void 0 : (_activeStar_focus = activeStar.focus) === null || _activeStar_focus === void 0 ? void 0 : _activeStar_focus.call(activeStar);
                }
            };
            stars.forEach((star)=>star.addEventListener("keydown", handleKeyDown));
            return ()=>{
                stars.forEach((star)=>star.removeEventListener("keydown", handleKeyDown));
            };
        }
    }, []);
    return ratingContainerRef;
};
/* harmony default export */ const util_useRatingKeyboard = (useRatingKeyboard);

;// CONCATENATED MODULE: ./src/components/dataDisplay/Rating/messages.tsx
/* harmony default export */ const messages = ({
    selectableLabel: {
        en: "Select rating"
    },
    readonlyLabel: {
        en: "{value} out of 5"
    },
    item: {
        en: "{value, plural, one {# star} other {# stars}}"
    },
    emptyHint: {
        en: "Tap to rate"
    },
    valueHint: {
        5: {
            en: "Amazing"
        },
        4: {
            en: "Very good"
        },
        3: {
            en: "Pretty good"
        },
        2: {
            en: "Needs improvement"
        },
        1: {
            en: "Not for me"
        }
    }
});

;// CONCATENATED MODULE: ./src/components/dataDisplay/Rating/Rating.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Rating_module = ({"rating":"u5y6GW","star":"H1IYDY","fill":"zdcg42","button":"OSAJIf","size-40":"XNOhhJ","size-20":"jyi4r9","size-14":"g4onrI","size-9":"qWOPMe"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/Rating/Rating.tsx











const sizes = (/* unused pure expression or super */ null && ([
    40,
    20,
    14,
    9
]));
const ReadonlyRating = (props)=>{
    const { className, value, size, fillStyle = "bg-gold-50", ...otherProps } = props;
    const intl = (0,useIntl/* default */.Z)();
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(otherProps);
    const label = intl.formatMessage(messages.readonlyLabel, {
        value
    });
    const items = array/* default */.Z.range(1, 5).map((itemValue)=>{
        // width of the current item from 0 to 1
        const part = Math.max(0, Math.min(1, value - itemValue + 1));
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: Rating_module.star,
            children: part > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx/* default */.Z)(Rating_module.fill, fillStyle),
                style: {
                    width: `${100 * part}%`
                }
            })
        }, itemValue);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        ...htmlAttrs,
        className: (0,clsx/* default */.Z)(Rating_module.rating, className, Rating_module[`size-${size}`]),
        "aria-label": label,
        role: "img",
        children: items
    });
};
const ControlledRating = (props)=>{
    const { className, value, size, withHint, onChange, hintPosition, fillStyle = "bg-gold-50", ...otherProps } = props;
    const [hoveredValue, setHoveredValue] = (0,react.useState)(null);
    // width of the current item from 0 to 1
    const currentValue = hoveredValue || value;
    const resetHoveredValue = (0,react.useCallback)(()=>{
        setHoveredValue(null);
    }, []);
    const intl = (0,useIntl/* default */.Z)();
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(otherProps);
    const ratingContainerRef = util_useRatingKeyboard({
        activeRating: currentValue
    });
    const label = intl.formatMessage(messages.selectableLabel);
    const items = array/* default */.Z.range(1, 5).map((itemValue)=>{
        const part = Math.max(0, Math.min(1, currentValue - itemValue + 1));
        const label = intl.formatMessage(messages.item, {
            value: itemValue
        });
        const handleClick = ()=>{
            onChange(itemValue);
        };
        const handleMouseEnter = ()=>{
            setHoveredValue(itemValue);
        };
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
            className: Rating_module.button,
            type: "button",
            "aria-label": label,
            onClick: handleClick,
            onMouseEnter: handleMouseEnter,
            onFocus: handleMouseEnter,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: Rating_module.star,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (0,clsx/* default */.Z)(Rating_module.fill, fillStyle),
                    style: {
                        width: `${100 * part}%`
                    }
                })
            })
        }, itemValue);
    });
    const labelId = (0,useUniqueId/* default */.Z)("rating");
    const withTopHint = withHint && hintPosition === "top";
    const withBottomHint = withHint && !withTopHint;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            withTopHint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mb-16",
                message: messages.valueHint[currentValue] || messages.emptyHint,
                color: "black",
                style: "p4"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ...htmlAttrs,
                ref: ratingContainerRef,
                className: (0,clsx/* default */.Z)(Rating_module.rating, className, Rating_module[`size-${size}`]),
                "aria-label": label,
                "aria-describedby": labelId,
                "data-testid": "selectableRating",
                onMouseLeave: resetHoveredValue,
                children: items
            }),
            withBottomHint && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-4",
                message: messages.valueHint[currentValue] || messages.emptyHint,
                color: currentValue ? "gold-50" : "black",
                style: "p4"
            })
        ]
    });
};
// ATTN we use two components to reuse styles and minimize dom elements for performance
const Rating = (props)=>{
    if (typeof props.onChange === "function") {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ControlledRating, {
            ...props
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ReadonlyRating, {
        ...props
    });
};
/* harmony default export */ const Rating_Rating = (/*#__PURE__*/react.memo(Rating));


/***/ }),

/***/ 61592:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78565);



const ReadonlyInput = (props)=>{
    const { className, label, value, "data-testid": dataTestId } = props;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                style: "t3",
                message: label,
                color: "gray-80"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                style: "p2",
                message: value,
                "data-testid": dataTestId
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReadonlyInput);


/***/ }),

/***/ 19384:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ RichText_RichText)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/modules/strapi/getRichTextStateFromMessage.ts + 1 modules
var getRichTextStateFromMessage = __webpack_require__(26676);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
;// CONCATENATED MODULE: ./src/components/dataDisplay/RichText/util/index.ts

const BOLD_FORMAT_NUMBER = 1;
const UNDERLINE_FORMAT_NUMBER = 1 << 3;
const wrapNode = (param)=>{
    let { content, format, fontColor, url, topIndent } = param;
    const styles = getNodeClassnames({
        format,
        fontColor,
        topIndent
    });
    if (url) {
        return `<Href className="${styles}" to="${url}">${content}</Href>`;
    }
    return styles ? `<span class="${styles}">${content}</span>` : content;
};
const getNodeClassnames = (param)=>{
    let { format, fontColor, topIndent } = param;
    let styles = [];
    if (topIndent) {
        styles.push(`mt-${topIndent}`);
    }
    if (fontColor) {
        styles.push(`text-${fontColor}`);
    }
    if (format === "left") {
        styles.push("text-left");
    }
    if (format === "right") {
        styles.push("text-right");
    }
    if (format === "center") {
        styles.push("text-center");
    }
    if ((format & BOLD_FORMAT_NUMBER) !== 0) {
        styles.push("font-bold");
    }
    if ((format & UNDERLINE_FORMAT_NUMBER) !== 0) {
        styles.push("underline");
    }
    return styles.join(" ");
};
const renderNestedNodes = (nodes)=>{
    return nodes === null || nodes === void 0 ? void 0 : nodes.reduce((blockText, node)=>{
        const { type, children, format, text, fontColor, url, topIndent } = node;
        const hasStyles = Boolean(format || fontColor || topIndent);
        const hasWrapper = hasStyles || Boolean(url);
        const hasNestedNodes = Boolean(text || children);
        if (hasWrapper || hasNestedNodes) {
            const content = children ? renderNestedNodes(children) : text;
            return blockText + wrapNode({
                url,
                format,
                fontColor,
                content,
                topIndent
            });
        }
        if (!text || type === "linebreak") {
            return blockText + "<br />";
        }
        return blockText + text;
    }, "");
};

;// CONCATENATED MODULE: ./src/components/dataDisplay/RichText/RichText.tsx





const RichText = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    let { className, children, message, "data-testid": dataTestId } = props;
    const formattedBlock = (0,react.useMemo)(()=>{
        var _editorState_root;
        const editorState = typeof message === "string" ? (0,getRichTextStateFromMessage/* default */.Z)(message) : message;
        if (!(editorState === null || editorState === void 0 ? void 0 : (_editorState_root = editorState.root) === null || _editorState_root === void 0 ? void 0 : _editorState_root.children)) {
            return null;
        }
        return editorState.root.children.map((node, index)=>{
            const { type, style, children } = node;
            const classNames = getNodeClassnames(node);
            const formattedText = renderNestedNodes(children);
            if (type === "linebreak" || !formattedText) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}, index);
            }
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                style: style,
                className: classNames,
                message: formattedText,
                html: true
            }, index);
        });
    }, [
        message
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: className,
        "data-testid": dataTestId,
        children: [
            formattedBlock === null || formattedBlock === void 0 ? void 0 : formattedBlock.map((block)=>block),
            children
        ]
    });
});
/* harmony default export */ const RichText_RichText = (RichText);


/***/ }),

/***/ 35755:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var components_navigation__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45881);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(19384);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77883);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(49952);





const RichTextPromoCardContainer = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)((props, ref)=>{
    const { children, className, message, label, action, indent = 16 } = props;
    const messageContent = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "relative",
        style: {
            marginTop: `-${indent}rem`
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            message: message
        })
    });
    if (action) {
        const { to, toTab, href, onClick } = action;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(components_navigation__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            className: className,
            to: to,
            toTab: toTab,
            href: href,
            onClick: onClick,
            ref: ref,
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative pl-16",
                    children: [
                        Boolean(label) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                            className: "!absolute !bottom-[calc(100%+16rem)] left-0",
                            richText: label,
                            bgColor: "black"
                        }),
                        messageContent,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_inputs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            className: "mt-16",
                            title: action.title,
                            style: "gold-50"
                        })
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: className,
        ref: ref,
        children: [
            children,
            messageContent
        ]
    });
});
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (/*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_1__.memo(RichTextPromoCardContainer));


/***/ }),

/***/ 78565:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  ZP: () => (/* binding */ Text_Text)
});

// UNUSED EXPORTS: alignToClassName, colorToClassName, styleToClassName

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/intl/Message.tsx + 1 modules
var Message = __webpack_require__(927);
// EXTERNAL MODULE: ./src/helpers/getters/getGlobalHtmlAttrs.ts
var getGlobalHtmlAttrs = __webpack_require__(614);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Text/Text.module.css
// extracted by mini-css-extract-plugin
/* harmony default export */ const Text_module = ({"text":"MnuRIF","linkStyle":"POI0zU"});
;// CONCATENATED MODULE: ./src/components/dataDisplay/Text/Text.tsx






const styleToClassName = {
    "h1": "text-h1",
    "h2": "text-h2",
    "h3": "text-h3",
    "h4": "text-h4",
    "h5": "text-h5",
    "h6": "text-h6",
    "h7": "text-h7",
    "h8": "text-h8",
    "h9": "text-h9",
    "sh1": "text-sh1",
    "sh2": "text-sh2",
    "sh3": "text-sh3",
    "sh4": "text-sh4",
    "sh5": "text-sh5",
    "sh6": "text-sh6",
    "p1": "text-p1",
    "p2": "text-p2",
    "p3": "text-p3",
    "p4": "text-p4",
    "p5": "text-p5",
    "p6": "text-p6",
    "eye1": "text-eye1",
    "eye2": "text-eye2",
    "eye3": "text-eye3",
    "t1": "text-t1",
    "t2": "text-t2",
    "t3": "text-t3",
    "t4": "text-t4",
    "t5": "text-t5",
    "t6": "text-t6",
    "t7": "text-t7"
};
const colorToClassName = {
    "gray-30": "text-gray-30",
    "gray-40": "text-gray-40",
    "gray-50": "text-gray-50",
    "gray-70": "text-gray-70",
    "gray-80": "text-gray-80",
    "gray-90": "text-gray-90",
    "white": "text-white",
    "black": "text-black",
    "gold-30": "text-gold-30",
    "gold-50": "text-gold-50",
    "gold-70": "text-gold-70",
    "red": "text-red",
    "pink": "text-pink",
    "dark-pink": "text-dark-pink",
    "faded-pink": "text-faded-pink",
    "dark-red": "text-dark-red",
    "light-beige": "text-light-beige",
    "orange": "text-orange"
};
const alignToClassName = {
    "left": "text-left",
    "right": "text-right",
    "center": "text-center"
};
const Text = /*#__PURE__*/ react.forwardRef((props, ref)=>{
    let { children, id, className, tag = "div", messageTag, message, style, color, align, html, withInnerLinksStyling, onClick, ...otherProps } = props;
    if (onClick && tag !== "button") {
        console.error('You can\'t use "onClick" without passing tag === "button". Create components ADA friendly!');
    }
    const rootClassName = (0,clsx/* default */.Z)(Text_module.text, className, styleToClassName[style], colorToClassName[color], alignToClassName[align], withInnerLinksStyling || html && withInnerLinksStyling !== false && Text_module.linkStyle);
    const htmlAttrs = (0,getGlobalHtmlAttrs/* default */.Z)(otherProps);
    if (message) {
        children = /*#__PURE__*/ (0,jsx_runtime.jsx)(Message/* default */.Z, {
            value: message,
            tag: messageTag,
            html: html
        });
    }
    return /*#__PURE__*/ react.createElement(tag, {
        ...htmlAttrs,
        ref,
        id,
        className: rootClassName,
        onClick
    }, children);
});
Text.displayName = "Text";
/* harmony default export */ const Text_Text = (Text);


/***/ }),

/***/ 1963:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78364);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53297);
/* harmony import */ var _loadable_component__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25747);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45600);






const Video = (props)=>{
    const { className, videoClassName, type, aspect = 100 / 56.25, fit, withBackground = true, "data-testid": dataTestId, ...rest } = props;
    const loggerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(false);
    let Component = null;
    const playInModal = rest.playInModal && rest.preview && rest.preview !== rest.url;
    if (playInModal) {
        Component = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
            resolved: {},
            chunkName () {
                return "components-PlayInModal-PlayInModal";
            },
            isReady (props) {
                const key = this.resolve(props);
                if (this.resolved[key] !== true) {
                    return false;
                }
                if (true) {
                    return !!__webpack_require__.m[key];
                }
                return false;
            },
            importAsync: ()=>__webpack_require__.e(/* import() | components-PlayInModal-PlayInModal */ 1262).then(__webpack_require__.bind(__webpack_require__, 64263)),
            requireAsync (props) {
                const key = this.resolve(props);
                this.resolved[key] = false;
                return this.importAsync(props).then((resolved)=>{
                    this.resolved[key] = true;
                    return resolved;
                });
            },
            requireSync (props) {
                const id = this.resolve(props);
                if (true) {
                    return __webpack_require__(id);
                }
                return eval("module.require")(id);
            },
            resolve () {
                if (true) {
                    return /*require.resolve*/(64263);
                }
                return eval("require.resolve")("./components/PlayInModal/PlayInModal");
            }
        });
    } else {
        switch(type === null || type === void 0 ? void 0 : type.toLowerCase()){
            case "mp4":
                Component = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                    resolved: {},
                    chunkName () {
                        return "components-MP4-MP4";
                    },
                    isReady (props) {
                        const key = this.resolve(props);
                        if (this.resolved[key] !== true) {
                            return false;
                        }
                        if (true) {
                            return !!__webpack_require__.m[key];
                        }
                        return false;
                    },
                    importAsync: ()=>__webpack_require__.e(/* import() | components-MP4-MP4 */ 1262).then(__webpack_require__.bind(__webpack_require__, 53293)),
                    requireAsync (props) {
                        const key = this.resolve(props);
                        this.resolved[key] = false;
                        return this.importAsync(props).then((resolved)=>{
                            this.resolved[key] = true;
                            return resolved;
                        });
                    },
                    requireSync (props) {
                        const id = this.resolve(props);
                        if (true) {
                            return __webpack_require__(id);
                        }
                        return eval("module.require")(id);
                    },
                    resolve () {
                        if (true) {
                            return /*require.resolve*/(53293);
                        }
                        return eval("require.resolve")("./components/MP4/MP4");
                    }
                });
                break;
            case "youtube":
                Component = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                    resolved: {},
                    chunkName () {
                        return "components-YoutubePlayer-YoutubePlayer";
                    },
                    isReady (props) {
                        const key = this.resolve(props);
                        if (this.resolved[key] !== true) {
                            return false;
                        }
                        if (true) {
                            return !!__webpack_require__.m[key];
                        }
                        return false;
                    },
                    importAsync: ()=>__webpack_require__.e(/* import() | components-YoutubePlayer-YoutubePlayer */ 1262).then(__webpack_require__.bind(__webpack_require__, 44141)),
                    requireAsync (props) {
                        const key = this.resolve(props);
                        this.resolved[key] = false;
                        return this.importAsync(props).then((resolved)=>{
                            this.resolved[key] = true;
                            return resolved;
                        });
                    },
                    requireSync (props) {
                        const id = this.resolve(props);
                        if (true) {
                            return __webpack_require__(id);
                        }
                        return eval("module.require")(id);
                    },
                    resolve () {
                        if (true) {
                            return /*require.resolve*/(44141);
                        }
                        return eval("require.resolve")("./components/YoutubePlayer/YoutubePlayer");
                    }
                });
                break;
            case "vimeo":
                Component = (0,_loadable_component__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
                    resolved: {},
                    chunkName () {
                        return "components-VimeoPlayer-VimeoPlayer";
                    },
                    isReady (props) {
                        const key = this.resolve(props);
                        if (this.resolved[key] !== true) {
                            return false;
                        }
                        if (true) {
                            return !!__webpack_require__.m[key];
                        }
                        return false;
                    },
                    importAsync: ()=>Promise.all(/* import() | components-VimeoPlayer-VimeoPlayer */[__webpack_require__.e(1262), __webpack_require__.e(7450)]).then(__webpack_require__.bind(__webpack_require__, 98371)),
                    requireAsync (props) {
                        const key = this.resolve(props);
                        this.resolved[key] = false;
                        return this.importAsync(props).then((resolved)=>{
                            this.resolved[key] = true;
                            return resolved;
                        });
                    },
                    requireSync (props) {
                        const id = this.resolve(props);
                        if (true) {
                            return __webpack_require__(id);
                        }
                        return eval("module.require")(id);
                    },
                    resolve () {
                        if (true) {
                            return /*require.resolve*/(98371);
                        }
                        return eval("require.resolve")("./components/VimeoPlayer/VimeoPlayer");
                    }
                });
                break;
            default:
                if (!loggerRef.current) {
                    loggerRef.current = true;
                    logger__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z.error({
                        props
                    }, "Video type is not recognized");
                }
                break;
        }
    }
    if (Component) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            className: (0,classnames__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(className, withBackground && "bg-black"),
            aspect: aspect,
            fit: fit,
            "data-testid": dataTestId,
            children: /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.createElement(Component, {
                ...rest,
                className: videoClassName,
                type
            })
        });
    }
    return null;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Video);


/***/ }),

/***/ 53293:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ MP4_MP4)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Video/components/MP4/messages.ts
/* harmony default export */ const messages = ({
    noSupport: {
        en: "Your browser does not support the video tag."
    }
});

;// CONCATENATED MODULE: ./src/components/dataDisplay/Video/components/MP4/MP4.tsx





const MP4 = (props)=>{
    const { className, url, preview, autoplay, muted, loop, controls, videoRef, onPlay, onPause, onVideoEnds, onClick } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
        className: (0,clsx/* default */.Z)(className, "absolute left-0 top-0 h-full w-full"),
        src: url,
        ref: videoRef,
        poster: preview,
        autoPlay: autoplay,
        playsInline: true,
        muted: muted,
        loop: loop,
        controls: controls,
        onPlay: onPlay,
        onPause: onPause,
        onEnded: onVideoEnds,
        onClick: onClick,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
            message: messages.noSupport,
            style: "p3"
        })
    });
};
/* harmony default export */ const MP4_MP4 = (MP4);


/***/ }),

/***/ 64263:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39977);
/* harmony import */ var _Preview_Preview__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46521);




const PlayInModal = (props)=>{
    const { className, url, type, preview, previewStyle, onPlay, onEnded } = props;
    const handlePlaceholderClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        if (typeof onPlay === "function") {
            onPlay();
        }
        (0,modals__WEBPACK_IMPORTED_MODULE_2__/* .openModal */ .h7)("videoModal", {
            type: type,
            url,
            onEnded
        });
    }, [
        onPlay,
        url,
        type,
        onEnded
    ]);
    const handlePlaceholderMouseOver = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        void (0,modals__WEBPACK_IMPORTED_MODULE_2__/* .preloadModal */ .My)("videoModal");
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Preview_Preview__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        className: className,
        bgImage: preview,
        previewStyle: previewStyle,
        onClick: handlePlaceholderClick,
        onMouseOver: handlePlaceholderMouseOver
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (PlayInModal);


/***/ }),

/***/ 46521:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Z: () => (/* binding */ Preview_Preview)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 5 modules
var Image = __webpack_require__(76884);
// EXTERNAL MODULE: ./src/components/inputs/Button/messages.ts
var messages = __webpack_require__(34212);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
// EXTERNAL MODULE: ./src/components/dataDisplay/PlayIcon/PlayIcon.tsx
var PlayIcon = __webpack_require__(85319);
;// CONCATENATED MODULE: ./src/components/dataDisplay/Video/components/Preview/VideoPreviewIcon.tsx




const VideoPreviewIcon = (param)=>{
    let { style } = param;
    if (style === "withoutIcon") {
        return null;
    }
    if (style === "drift") {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "absolute bottom-16 right-16 flex items-center rounded-full bg-white py-8 pl-16 pr-12",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "mr-6",
                    style: "h8",
                    message: messages/* default */.Z.playVideo
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* default */.Z, {
                    size: 18,
                    style: "drift"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "absolute left-[50%] top-[50%] -translate-x-1/2 -translate-y-1/2",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PlayIcon/* default */.Z, {
            size: style === "gold30" ? 60 : 72,
            style: style === "gold30" ? "gold-30" : "default"
        })
    });
};
/* harmony default export */ const Preview_VideoPreviewIcon = (VideoPreviewIcon);

;// CONCATENATED MODULE: ./src/components/dataDisplay/Video/components/Preview/Preview.tsx





const Preview = (props)=>{
    const { className, bgImage, previewStyle, onClick, onMouseOver } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "absolute left-0 top-0 h-full w-full cursor-pointer bg-cover bg-center outline-none"),
        role: "button",
        tabIndex: 0,
        onClick: onClick,
        onMouseOver: onMouseOver,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                fill: true,
                src: bgImage,
                alt: "Poster"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Preview_VideoPreviewIcon, {
                style: previewStyle
            })
        ]
    });
};
/* harmony default export */ const Preview_Preview = (Preview);


/***/ }),

/***/ 98371:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var _vimeo_player__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77015);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78364);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(83305);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96934);
/* harmony import */ var _Preview_Preview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46521);







const VimeoPlayer = (props)=>{
    const { url, autoplay, muted, loop, controls = true, autopause, onReady, onPlay, onPause, onEnded, onError, className, preview, previewStyle } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const [isVideoVisible, setVideoVisibility] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(!preview);
    // should we start video right after loading
    const autoplayRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(autoplay && !preview);
    // due to restrictions on autoplaying video in mobile browsers, we have to mute the sound for autoplay to work.
    const mutedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(autoplay && isMobile ? true : muted);
    const containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const playerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // all options are passed using src args
    const src = `${url}?muted=${mutedRef.current ? 1 : 0}&controls=${controls ? 1 : 0}&loop=${loop ? 1 : 0}&autopause=${autopause ? 1 : 0}&autoplay=${autoplayRef.current ? 1 : 0}`;
    const createPlayer = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(async ()=>{
        // we don't use it to create a player, but only to control it
        playerRef.current = new _vimeo_player__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z(containerRef.current);
        playerRef.current.on("loaded", ()=>{
            if (typeof onReady === "function") {
                onReady();
            }
        });
        playerRef.current.on("play", ()=>{
            if (typeof onPlay === "function") {
                onPlay();
            }
        });
        playerRef.current.on("pause", ()=>{
            if (typeof onPause === "function") {
                onPause();
            }
        });
        playerRef.current.on("ended", ()=>{
            if (typeof onEnded === "function") {
                onEnded();
            }
        });
        playerRef.current.on("error", (error)=>{
            onError(error);
            throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .SilentError */ ._R(error);
        });
    }, [
        onEnded,
        onError,
        onPause,
        onPlay,
        onReady
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const isContainerExist = containerRef.current;
        if (isContainerExist && isVideoVisible) {
            createPlayer().catch((error)=>{
                throw new helpers__WEBPACK_IMPORTED_MODULE_4__/* .SilentError */ ._R(error);
            });
        }
        return ()=>{
            if (playerRef.current) {
                void playerRef.current.destroy();
                playerRef.current = null;
            }
        };
    }, [
        createPlayer,
        isVideoVisible
    ]);
    const handlePreviewClick = ()=>{
        autoplayRef.current = true;
        setVideoVisibility(true);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: isVideoVisible ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
            ref: containerRef,
            className: (0,classnames__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(className, "absolute left-0 top-0 h-full w-full"),
            src: src,
            frameBorder: "0",
            allow: "autoplay;encrypted-media;fullscreen;picture-in-picture"
        }, url) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Preview_Preview__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            bgImage: preview,
            previewStyle: previewStyle,
            onClick: handlePreviewClick
        })
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (VimeoPlayer);


/***/ }),

/***/ 44141:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85183);
/* harmony import */ var core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_push_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52983);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78364);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96934);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(53297);
/* harmony import */ var _Preview_Preview__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46521);







const youtubeIframeAPIState = {
    isScriptInserted: false,
    isReady: false,
    onReadyWaitList: []
};
const initApi = (callback)=>{
    if (youtubeIframeAPIState.isReady) {
        callback();
        return;
    }
    youtubeIframeAPIState.onReadyWaitList.push(callback);
    if (youtubeIframeAPIState.isScriptInserted) {
        return;
    }
    const tag = document.createElement("script");
    tag.src = "https://www.youtube.com/iframe_api";
    const firstScriptTag = document.getElementsByTagName("script")[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    youtubeIframeAPIState.isScriptInserted = true;
    window.onYouTubeIframeAPIReady = ()=>{
        youtubeIframeAPIState.isReady = true;
        youtubeIframeAPIState.onReadyWaitList.forEach((callback)=>callback());
    };
};
const YoutubePlayer = (props)=>{
    const { className, url, preview, autoplay, previewStyle = "default", onPlay } = props;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useRef)();
    const [isPlayOn, setIsPlayOn] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(autoplay && !preview);
    const withPreview = Boolean(preview && preview !== url);
    const src = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(()=>{
        if (autoplay || withPreview) {
            const hasQuery = /\?[^?]+$/.test(url);
            return `${url}${hasQuery ? "&" : "?"}autoplay=1&enablejsapi=1`;
        }
        return url;
    }, [
        url,
        autoplay,
        withPreview
    ]);
    const [isVideoVisible, setVideoVisibility] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(!withPreview);
    const handlePlaceholderClick = (0,react__WEBPACK_IMPORTED_MODULE_2__.useCallback)(()=>{
        setVideoVisibility(true);
        if (typeof onPlay === "function") {
            onPlay();
        }
        setIsPlayOn(true);
    }, [
        onPlay
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (isMobile && isPlayOn) {
            // it's a big fallback for mobile devices
            // autoplay isn't working in mobile browsers, so we should start video manually by API
            // to do so, we should load iframe api
            initApi(()=>{
                // we need setTimeout, because iframe should be rendered after state update
                setTimeout(()=>{
                    try {
                        // @ts-ignore
                        const player = new window.YT.Player(ref.current, {
                            events: {
                                "onReady": ()=>{
                                    player.playVideo();
                                }
                            }
                        });
                    } catch (error) {
                        logger__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z.error(error);
                    }
                }, 50);
            });
        }
    }, [
        isMobile,
        isPlayOn
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            Boolean(withPreview) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Preview_Preview__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                bgImage: preview,
                previewStyle: previewStyle,
                onClick: handlePlaceholderClick
            }),
            isVideoVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("iframe", {
                ref: ref,
                className: (0,classnames__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(className, "absolute left-0 top-0 h-full w-full"),
                src: src,
                title: "youtube video",
                allow: "autoplay",
                frameBorder: "0",
                allowFullScreen: true
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (YoutubePlayer);


/***/ }),

/***/ 28362:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97458);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19460);
/* harmony import */ var modals__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(39977);
/* harmony import */ var components_inputs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34212);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78565);
/* harmony import */ var components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85319);






const VideoButton = (props)=>{
    const { className, type, url, title = components_inputs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z.playVideo, style = "default", iconStyle = "drift", onClick, onEnded } = props;
    const handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((event)=>{
        if (typeof onClick === "function") {
            onClick(event, {
                type,
                url
            });
        }
        (0,modals__WEBPACK_IMPORTED_MODULE_3__/* .openModal */ .h7)("videoModal", {
            type,
            url,
            onEnded
        });
    }, [
        type,
        url,
        onClick,
        onEnded
    ]);
    const handleMouseOver = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(()=>{
        void (0,modals__WEBPACK_IMPORTED_MODULE_3__/* .preloadModal */ .My)("videoModal");
    }, []);
    const buttonClassName = (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .twcx */ .L)("flex items-center rounded-full py-8 pl-16 pr-12 bg-white text-black", style === "inverted" && "text-white bg-black", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
        type: "button",
        className: buttonClassName,
        onClick: handleClick,
        onMouseOver: handleMouseOver,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP, {
                className: "mr-6",
                style: "h8",
                message: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_dataDisplay__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                size: 18,
                style: iconStyle
            })
        ]
    });
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (VideoButton);


/***/ }),

/***/ 23431:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__.p + "images-svg/product-with-plus_d5b61b.svg";

/***/ })

}]);